// @ts-nocheck
import TataIcon from "@public/images/makeImages/Tata.svg";
import HyundaiIcon from "@public/images/makeImages/Hyundai.svg";
import MarutiIcon from "@public/images/makeImages/Maruti.svg";
import MahindraIcon from "@public/images/makeImages/Mahindra.svg";
import HondaDummyAsBmwIcon from "@public/images/makeImages/HondaDummyAsBmw.svg";
import KiaDummyAsJaguarIcon from "@public/images/makeImages/KiaDummyAsJaguar.svg";
import { isEmpty } from "./lodash";

export const organizeCarsByMake = (data) => {
  const organizedData = {};

  data.forEach((car) => {
    const [make, ...model ] = car.name.split(" ");
    const finalModelName = model.join(' ');

    if (!organizedData[make]) {
      organizedData[make] = {
        logo: "https://storefront-consumer-assets.s3.ap-south-1.amazonaws.com/static/plan/return-to-invoice-bike.svg",
        models: []
      }; 
    }
    if (organizedData[make].models.indexOf(finalModelName) == -1) {
      organizedData[make].models = [
        ...organizedData[make].models,
        {
           model_name: finalModelName, variants: [] 
        }
      ];
    }
    organizedData[make].models.forEach(modeln => {
      if (modeln?.model_name === finalModelName) { modeln?.variants?.push(...car?.variants); }
    })
  });

  return organizedData;
};

export const MMV_DATA = {
  Honda: {
    logo: "https://storefront-consumer-assets.s3.ap-south-1.amazonaws.com/static/mmv/honda_logo.svg",
    models: [
      {
        model_name: "New Jazz",
        variants: [
          {
            id: "O-EfVOGnz3Uxv7rearLLyg",
            name: "V",
            fuel_type: "petrol",
            cc: 1199,
            transmission_type: "manual",
          },
          {
            id: "-OtLN6PtP-8RVe-vF2musA",
            name: "V",
            fuel_type: "diesel",
            cc: 1498,
            transmission_type: "manual",
          },
          {
            id: "yhuhxZeRgDXzeGoyhJp4lg",
            name: "VX",
            fuel_type: "petrol",
            cc: 1199,
            transmission_type: "manual",
          },
          {
            id: "mbIlAkJ5UBQWYi9H2FYjgw",
            name: "VX",
            fuel_type: "diesel",
            cc: 1498,
            transmission_type: "manual",
          },
          {
            id: "uZrJuEFDkao3N-DzcHF8MQ",
            name: "VX CVT",
            fuel_type: "petrol",
            cc: 1199,
            transmission_type: "automatic",
          },
          {
            id: "yUcjci6_KfayGSRGTsiLiA",
            name: "E",
            fuel_type: "petrol",
            cc: 1199,
            transmission_type: "manual",
          },
          {
            id: "0qF8Bs5_y2zUC4VxbWlFKQ",
            name: "SV",
            fuel_type: "diesel",
            cc: 1498,
            transmission_type: "manual",
          },
          {
            id: "DvI2LAeK3SflizH7ksfmOg",
            name: "S",
            fuel_type: "diesel",
            cc: 1498,
            transmission_type: "manual",
          },
          {
            id: "_o-qVemsl08QwCYJOL35LQ",
            name: "E",
            fuel_type: "diesel",
            cc: 1498,
            transmission_type: "manual",
          },
          {
            id: "TvBw1kaF-GKlWGiJgi9Aiw",
            name: "SV",
            fuel_type: "petrol",
            cc: 1199,
            transmission_type: "manual",
          },
          {
            id: "NfMJKVNqAWZ-UuzRYtaOIw",
            name: "V AT",
            fuel_type: "petrol",
            cc: 1199,
            transmission_type: "automatic",
          },
          {
            id: "-vODPMkb16VMXYQnvbXcmA",
            name: "S",
            fuel_type: "petrol",
            cc: 1199,
            transmission_type: "manual",
          },
          {
            id: "1q8DjEc2vOzU2m4JBE-g0g",
            name: "S AT",
            fuel_type: "petrol",
            cc: 1199,
            transmission_type: "automatic",
          },
        ],
      },
      {
        model_name: "Jazz",
        variants: [
          {
            id: "v__XlcvBe6d4gXx6IB-zWw",
            name: "Privilege Edition AT Petrol",
            fuel_type: "petrol",
            cc: 1199,
            transmission_type: "automatic",
          },
          {
            id: "Ncr-pxxBuHPCrhJljtdMOg",
            name: "Privilege Edition Diesel",
            fuel_type: "diesel",
            cc: 1498,
            transmission_type: "manual",
          },
          {
            id: "SXHrPeLv0avhnjl9cR4G_Q",
            name: "X Old",
            fuel_type: "petrol",
            cc: 1198,
            transmission_type: "manual",
          },
          {
            id: "pzE54qOZ75GvdYWULEy0tQ",
            name: "E Petrol",
            fuel_type: "petrol",
            cc: 1199,
            transmission_type: "manual",
          },
          {
            id: "qlLxs0K4ip3HZ1WicmP3qg",
            name: "Privilege Edition Petrol",
            fuel_type: "petrol",
            cc: 1199,
            transmission_type: "manual",
          },
          {
            id: "wb75m2thYRsnykKvmCidsg",
            name: "S AT Petrol",
            fuel_type: "petrol",
            cc: 1199,
            transmission_type: "automatic",
          },
          {
            id: "Q-_NyClImJJfy8iplQI6fA",
            name: "S Petrol",
            fuel_type: "petrol",
            cc: 1199,
            transmission_type: "manual",
          },
          {
            id: "b5qF1aM7CkeI-rBrjf_bLA",
            name: "1.2 V i VTEC",
            fuel_type: "petrol",
            cc: 1199,
            transmission_type: "manual",
          },
          {
            id: "DCD1fBodd_cqECHsV6-KtA",
            name: "Select",
            fuel_type: "petrol",
            cc: 1198,
            transmission_type: "manual",
          },
          {
            id: "qOBC4kRbG8FFSjLi_lfIUQ",
            name: "SV Petrol",
            fuel_type: "petrol",
            cc: 1199,
            transmission_type: "manual",
          },
          {
            id: "aqQhQbEeqOlz_b9wViWiOg",
            name: "1.2 V CVT",
            fuel_type: "petrol",
            cc: 1199,
            transmission_type: "automatic",
          },
          {
            id: "LMx1kOipIQ0U7hytWrwi0w",
            name: "1.2 V At (1198 Cc)",
            fuel_type: "petrol",
            cc: 1198,
            transmission_type: "automatic",
          },
          {
            id: "aGEhFwKedMxspSeZKyuo0g",
            name: "1.2 V Mt (1198 Cc)",
            fuel_type: "petrol",
            cc: 1198,
            transmission_type: "manual",
          },
          {
            id: "xF-AOtyWIdlUEE5bylzOkQ",
            name: "1.5 Vx Mt (1498 Cc)",
            fuel_type: "diesel",
            cc: 1498,
            transmission_type: "manual",
          },
          {
            id: "zQtRLoCVhlzmwqSyGzgqPg",
            name: "E",
            fuel_type: "diesel",
            cc: 1498,
            transmission_type: "manual",
          },
          {
            id: "vhigvmDbXkr1i9suxpMYGQ",
            name: "V CVT Privilege Edition",
            fuel_type: "petrol",
            cc: 1199,
            transmission_type: "automatic",
          },
          {
            id: "YpdY0QYvQZDq05y23WGKDQ",
            name: "1.2 Select Edition (1198 Cc)",
            fuel_type: "petrol",
            cc: 1198,
            transmission_type: "manual",
          },
          {
            id: "L2wWHLpck15js6tq9zZZDg",
            name: "1.2 Sv Mt (1198 Cc)",
            fuel_type: "petrol",
            cc: 1198,
            transmission_type: "manual",
          },
          {
            id: "8zNgH40_vOVkb2I0iLpuxw",
            name: "1.5 E Mt (1498 Cc)",
            fuel_type: "diesel",
            cc: 1498,
            transmission_type: "manual",
          },
          {
            id: "vZgeXcsrpEWzqyIhL4SeAA",
            name: "1.5 Sv Mt (1498 Cc)",
            fuel_type: "diesel",
            cc: 1498,
            transmission_type: "manual",
          },
          {
            id: "iRwIuBwpnOLz3xR7o2wuzw",
            name: "1.5 V Mt (1498 Cc)",
            fuel_type: "diesel",
            cc: 1498,
            transmission_type: "manual",
          },
          {
            id: "7fMDjtAOh-RBPrhVYR6x-w",
            name: "VX AT Petrol",
            fuel_type: "petrol",
            cc: 1199,
            transmission_type: "automatic",
          },
          {
            id: "WM0ihe4uz65X-6QSMQucXg",
            name: "1.2 X",
            fuel_type: "petrol",
            cc: 1198,
            transmission_type: "manual",
          },
          {
            id: "LSQ4G2DisnJxLdihtxydwQ",
            name: "VTI",
            fuel_type: "petrol",
            cc: 1497,
            transmission_type: "manual",
          },
          {
            id: "tQBWn_VmuIiHbpxnunDd_w",
            name: "1.2 Mode",
            fuel_type: "petrol",
            cc: 1198,
            transmission_type: "manual",
          },
          {
            id: "cXjGfqa24qZPujMKd6F3Dw",
            name: "VX MT",
            fuel_type: "petrol",
            cc: 1199,
            transmission_type: "manual",
          },
          {
            id: "bhAgvP4HiqVznXmEYBxfxA",
            name: "Mode",
            fuel_type: "petrol",
            cc: 1198,
            transmission_type: "manual",
          },
          {
            id: "0NaJRjnM1kaEnDu71V8-Bg",
            name: "1.2 Active",
            fuel_type: "petrol",
            cc: 1198,
            transmission_type: "manual",
          },
          {
            id: "Mfl9dfYang_3CKfJOJ35bg",
            name: "1.2 S",
            fuel_type: "petrol",
            cc: 1198,
            transmission_type: "manual",
          },
          {
            id: "VSZHpQp_UMcbdIl7bKz5Hw",
            name: "1.2 MT",
            fuel_type: "petrol",
            cc: 1198,
            transmission_type: "manual",
          },
          {
            id: "tviWdbbdBwVzRjyhFKkWKg",
            name: "Active",
            fuel_type: "petrol",
            cc: 1349,
            transmission_type: "manual",
          },
          {
            id: "D-gm0fyGpjqdcGIV76R97w",
            name: "SV",
            fuel_type: "diesel",
            cc: 1498,
            transmission_type: "manual",
          },
          {
            id: "Ggu5nHy2ntriPXgfp804Yw",
            name: "S",
            fuel_type: "diesel",
            cc: 1498,
            transmission_type: "manual",
          },
          {
            id: "i1WaIW1PjSk9SAT6exX3pw",
            name: "VX",
            fuel_type: "diesel",
            cc: 1498,
            transmission_type: "manual",
          },
          {
            id: "8sUIoDOtrqiSzIeBJNTwtw",
            name: "V",
            fuel_type: "diesel",
            cc: 1498,
            transmission_type: "manual",
          },
          {
            id: "84VZjjRSaIIPaQarCL07-Q",
            name: "1.2 E Mt (1198 Cc)",
            fuel_type: "petrol",
            cc: 1198,
            transmission_type: "manual",
          },
          {
            id: "kGwv3EQQwZvESeUyNRC7EA",
            name: "1.2 S CVT",
            fuel_type: "petrol",
            cc: 1198,
            transmission_type: "automatic",
          },
          {
            id: "yMByBA6jyE2pxPPl6RS_Mw",
            name: "Exclusive Edition CVT",
            fuel_type: "petrol",
            cc: 1199,
            transmission_type: "automatic",
          },
          {
            id: "X6368VEbJ5v2W3_46VLqUQ",
            name: "BASE",
            fuel_type: "petrol",
            cc: 1198,
            transmission_type: "manual",
          },
          {
            id: "CyajZnLIWZxf_nKZO5ATMQ",
            name: "ZX",
            fuel_type: "petrol",
            cc: 1199,
            transmission_type: "manual",
          },
          {
            id: "vlM31gGhGPdE1TCHCiHwWw",
            name: "1.5 S Mt (1498 Cc)",
            fuel_type: "diesel",
            cc: 1498,
            transmission_type: "manual",
          },
          {
            id: "mHd_rJMQb5TdNJGXFvFKfQ",
            name: "1.2 S Mt (1198 Cc)",
            fuel_type: "petrol",
            cc: 1198,
            transmission_type: "manual",
          },
          {
            id: "hi67zdPEuZgfjNv94EQwDg",
            name: "VX AT",
            fuel_type: "petrol",
            cc: 1198,
            transmission_type: "automatic",
          },
          {
            id: "hCLZg1k4dvlzthzCoGj-HA",
            name: "ZX CVT",
            fuel_type: "petrol",
            cc: 1199,
            transmission_type: "automatic",
          },
        ],
      },
      {
        model_name: "City",
        variants: [
          {
            id: "q0xKsV0-swPh-7uREco7jA",
            name: "VX Petrol",
            fuel_type: "petrol",
            cc: 1497,
            transmission_type: "manual",
          },
          {
            id: "K1MKR7yOlu3_pl2ZRI_j6w",
            name: "V AT",
            fuel_type: "petrol",
            cc: 1493,
            transmission_type: "automatic",
          },
          {
            id: "fpHqSetcJ9WByR5afEdcbw",
            name: "V I-DTECH",
            fuel_type: "diesel",
            cc: 1498,
            transmission_type: "manual",
          },
          {
            id: "lBwN-9jzMsYj9ZHgw-wr2Q",
            name: "1.5 V AT SUNROOF",
            fuel_type: "petrol",
            cc: 1497,
            transmission_type: "automatic",
          },
          {
            id: "HZT99KCzAfnCVMnm2Tq77Q",
            name: "1.5 ZX VTEC ABS",
            fuel_type: "petrol",
            cc: 1497,
            transmission_type: "manual",
          },
          {
            id: "KB-BEz1xy0GmNslzYnclEQ",
            name: "1.5 V MT SUNROOF",
            fuel_type: "petrol",
            cc: 1497,
            transmission_type: "manual",
          },
          {
            id: "XC2MFWbmekJ9auuriOgvLQ",
            name: "1.5 ZX AT CVT",
            fuel_type: "petrol",
            cc: 1497,
            transmission_type: "automatic",
          },
          {
            id: "a42Ec32deVIKxi56YYN4Ww",
            name: "1.5 ZX GXI AT",
            fuel_type: "petrol",
            cc: 1497,
            transmission_type: "automatic",
          },
          {
            id: "SJwb0bzLQt1CVgi-oyFF1w",
            name: "1.5 V ELEGANCE",
            fuel_type: "petrol",
            cc: 1497,
            transmission_type: "manual",
          },
          {
            id: "Kd0SYxp2fdU_9LvCa8Gf3w",
            name: "1.5 V AT (AVN)",
            fuel_type: "petrol",
            cc: 1497,
            transmission_type: "automatic",
          },
          {
            id: "13WtKSkpLPCmRmIqPUm_hQ",
            name: "1.5 V AT EXCLUSIVE",
            fuel_type: "petrol",
            cc: 1497,
            transmission_type: "automatic",
          },
          {
            id: "q7pdWJA_SZ2jY_TPaTKl3Q",
            name: "1.5 V MT EXCLUSIVE",
            fuel_type: "petrol",
            cc: 1497,
            transmission_type: "manual",
          },
          {
            id: "3jtJlRujy6OdMSmqlnCy0w",
            name: "Vx (O) Mt (1497 Cc)",
            fuel_type: "petrol",
            cc: 1497,
            transmission_type: "manual",
          },
          {
            id: "OpVoD7GjKpeEtCtUli66Gw",
            name: "Vx (O) Mt Diesel (1498 Cc)",
            fuel_type: "diesel",
            cc: 1498,
            transmission_type: "manual",
          },
          {
            id: "9ijKWkBjkH7S_za79AKMlA",
            name: "1.5 Vx Cvt Auto Transmission (1497 Cc)",
            fuel_type: "petrol",
            cc: 1497,
            transmission_type: "automatic",
          },
          {
            id: "N5Zh9Q53VXbv3Cjglq9FBg",
            name: "1.5 V Cvt Auto Transmission (1497 Cc)",
            fuel_type: "petrol",
            cc: 1497,
            transmission_type: "automatic",
          },
          {
            id: "L48wzjK20ER1PSQkn4avtg",
            name: "1.5 Zx Exi (1497 Cc)",
            fuel_type: "petrol",
            cc: 1497,
            transmission_type: "manual",
          },
          {
            id: "AH9IlUGzUn9m3Zj7dGX87A",
            name: "ZX Diesel",
            fuel_type: "diesel",
            cc: 1498,
            transmission_type: "manual",
          },
          {
            id: "9M1SylgExcEGWxUi7jxUfA",
            name: "1.5 ZX MT IDTEC",
            fuel_type: "diesel",
            cc: 1488,
            transmission_type: "manual",
          },
          {
            id: "-vXPzG-KIS6FULXF_xqF3g",
            name: "1.5 ZX",
            fuel_type: "diesel",
            cc: 1498,
            transmission_type: "manual",
          },
          {
            id: "ucBBUhyRngRMgZmQgCDSfA",
            name: "1.5 SV",
            fuel_type: "petrol",
            cc: 1498,
            transmission_type: "manual",
          },
          {
            id: "SB7YYNnLubm5LW5qykERNA",
            name: "V MT CNG Compatible",
            fuel_type: "petrol",
            cc: 1497,
            transmission_type: "manual",
          },
          {
            id: "nSf98FG5HOpPPy3KqpTZKw",
            name: "SV Petrol",
            fuel_type: "petrol",
            cc: 1497,
            transmission_type: "manual",
          },
          {
            id: "DlPvKCr_3Akab9v1JGH4QA",
            name: "1.5 Vtec",
            fuel_type: "petrol",
            cc: 1493,
            transmission_type: "manual",
          },
          {
            id: "lpkjas5nn-fSGPYLoo7Q-w",
            name: "VX Option",
            fuel_type: "diesel",
            cc: 1498,
            transmission_type: "manual",
          },
          {
            id: "QqWYMi4sH0UjODt5u1AI3Q",
            name: "1.5 S ELEGANCE",
            fuel_type: "petrol",
            cc: 1497,
            transmission_type: "manual",
          },
          {
            id: "QYgdz8Rb_fPeB9Ul541PHA",
            name: "1.5 S INSPIRE",
            fuel_type: "petrol",
            cc: 1497,
            transmission_type: "manual",
          },
          {
            id: "cFGflYwT8vjf8T0vDhHu8g",
            name: "1.5 Sv Cvt Auto Transmission (1497 Cc)",
            fuel_type: "petrol",
            cc: 1497,
            transmission_type: "automatic",
          },
          {
            id: "Ion-bCbX3HGR1V8I2ZwiHw",
            name: "1.5 Sv Manual Transmission (1498 Cc)",
            fuel_type: "diesel",
            cc: 1498,
            transmission_type: "manual",
          },
          {
            id: "df6QeF3uvatW8uR35hnT8g",
            name: "i VTEC VX Option",
            fuel_type: "petrol",
            cc: 1497,
            transmission_type: "manual",
          },
          {
            id: "y8Ez6fae4CzItgGJUsBDXw",
            name: "ZXi AT",
            fuel_type: "petrol",
            cc: 1296,
            transmission_type: "automatic",
          },
          {
            id: "sKFGVKhNBnQiMtksFPPk1A",
            name: "1.3 LXI",
            fuel_type: "petrol",
            cc: 1343,
            transmission_type: "manual",
          },
          {
            id: "dg7maYaQDOYKnvIYboW5DQ",
            name: "1.5 Vitec",
            fuel_type: "petrol",
            cc: 1493,
            transmission_type: "manual",
          },
          {
            id: "2th2SjERc3NQ8VMBkLYqTA",
            name: "1.5 GXI",
            fuel_type: "petrol",
            cc: 1493,
            transmission_type: "manual",
          },
          {
            id: "GKjkH1koFqkGvZOAHmR9rA",
            name: "1.5 V MT",
            fuel_type: "internal_lpg_cng",
            cc: 1497,
            transmission_type: "manual",
          },
          {
            id: "7YV8_2rXkkpTR5IDOCm7Jg",
            name: "1.3 DX",
            fuel_type: "petrol",
            cc: 1343,
            transmission_type: "manual",
          },
          {
            id: "lsS_Sh5FeQVrSFz2BtVnQw",
            name: "1.5 EXI",
            fuel_type: "petrol",
            cc: 1497,
            transmission_type: "manual",
          },
          {
            id: "8VFxuOtrMQruxJW-TvfjUw",
            name: "1.5 ZXI",
            fuel_type: "petrol",
            cc: 1497,
            transmission_type: "manual",
          },
          {
            id: "zlAlxOii-AjILo5WQkxVoA",
            name: "1.6 ZXI",
            fuel_type: "petrol",
            cc: 1597,
            transmission_type: "manual",
          },
          {
            id: "n5eXrH7rnrucnqPaCNEjXA",
            name: "1.5 VX",
            fuel_type: "diesel",
            cc: 1498,
            transmission_type: "manual",
          },
          {
            id: "g5Yrc_dTbARiJKFvVo80mg",
            name: "1.5 V",
            fuel_type: "diesel",
            cc: 1498,
            transmission_type: "manual",
          },
          {
            id: "58DTgqeVj9vMb6XSOOKgxw",
            name: "1.5 ZX CVT",
            fuel_type: "petrol",
            cc: 1498,
            transmission_type: "automatic",
          },
          {
            id: "RWFjjXXL13j500qULK6gNQ",
            name: "1.5 SMT",
            fuel_type: "petrol",
            cc: 1498,
            transmission_type: "manual",
          },
          {
            id: "LjrAtBg-ID1iZ6IrZaPg4g",
            name: "1.5 V CVT",
            fuel_type: "petrol",
            cc: 1498,
            transmission_type: "automatic",
          },
          {
            id: "SR-p5LhLm98M5h9k8i37Zw",
            name: "1.5 ZX",
            fuel_type: "petrol",
            cc: 1498,
            transmission_type: "manual",
          },
          {
            id: "B01o_ZsX04t3Lw0zTQPUdg",
            name: "1.5 VX CVT",
            fuel_type: "petrol",
            cc: 1498,
            transmission_type: "automatic",
          },
          {
            id: "B8baV3jyhyaCLUyDA8HaSA",
            name: "1.5 VX",
            fuel_type: "petrol",
            cc: 1498,
            transmission_type: "manual",
          },
          {
            id: "v2EOpcI-2PL0sJEiqRDhmw",
            name: "1.5 VXO BL MT IVTEC",
            fuel_type: "petrol",
            cc: 1497,
            transmission_type: "manual",
          },
          {
            id: "FajNhTX-k-Jf5NX_3eG7-Q",
            name: "1.5 EXI AT",
            fuel_type: "petrol",
            cc: 1493,
            transmission_type: "automatic",
          },
          {
            id: "RytsXdEF9dYw2b_N5oatqw",
            name: "LXI",
            fuel_type: "petrol",
            cc: 1497,
            transmission_type: "manual",
          },
          {
            id: "oNywV0Arj_86HL-SNv62lw",
            name: "1.3 EXI",
            fuel_type: "petrol",
            cc: 1343,
            transmission_type: "manual",
          },
          {
            id: "rve3oeD-kpf38R5ikIEGJw",
            name: "EMT",
            fuel_type: "petrol",
            cc: 1497,
            transmission_type: "manual",
          },
          {
            id: "2PVq2XMPyMvP_A-Toj_JuA",
            name: "1.5 V",
            fuel_type: "petrol",
            cc: 1498,
            transmission_type: "manual",
          },
          {
            id: "la3EfWVUbp3X8XX82Q40AA",
            name: "1.5 I-DTec S MT",
            fuel_type: "diesel",
            cc: 1498,
            transmission_type: "manual",
          },
          {
            id: "9sk39hQWxmH1U1WI_sqcqg",
            name: "V Diesel",
            fuel_type: "diesel",
            cc: 1498,
            transmission_type: "manual",
          },
          {
            id: "DG7-OUJdghv58tS1lG3S4w",
            name: "VX Diesel",
            fuel_type: "diesel",
            cc: 1498,
            transmission_type: "manual",
          },
          {
            id: "b5riGmmLfVqGcprqDD943g",
            name: "i VTEC CVT VX",
            fuel_type: "petrol",
            cc: 1497,
            transmission_type: "automatic",
          },
          {
            id: "9gLuL0j84sLttgIoQet9cA",
            name: "1.5 V MT (AVN)",
            fuel_type: "petrol",
            cc: 1497,
            transmission_type: "manual",
          },
          {
            id: "mGG8FgDXheUYYxEAUYrjIg",
            name: "I vtec S",
            fuel_type: "petrol",
            cc: 1497,
            transmission_type: "manual",
          },
          {
            id: "7CmFFnt05O0rq2wn5lP6vA",
            name: "I DTec SV MT",
            fuel_type: "diesel",
            cc: 1498,
            transmission_type: "manual",
          },
          {
            id: "ZbVU3TriW7u1lNAb5DEGHA",
            name: "1.5 V CVT I VTEC",
            fuel_type: "petrol",
            cc: 1497,
            transmission_type: "automatic",
          },
        ],
      },
      {
        model_name: "Amaze",
        variants: [
          {
            id: "ve5aC_559JjK6CUNt_WM5g",
            name: "1.2 VX MT",
            fuel_type: "petrol",
            cc: 1198,
            transmission_type: "manual",
          },
          {
            id: "-NKMzuaMTHdKMWX5xMr7Dw",
            name: "1.2 VX AT",
            fuel_type: "petrol",
            cc: 1198,
            transmission_type: "automatic",
          },
          {
            id: "3FEzwD2Y8GL75NH0Ey1PZA",
            name: "1.5 VX MT",
            fuel_type: "diesel",
            cc: 1498,
            transmission_type: "manual",
          },
          {
            id: "xShD0TdckEN26zsNFKRCcQ",
            name: "VX (O)",
            fuel_type: "petrol",
            cc: 1198,
            transmission_type: "manual",
          },
          {
            id: "mpCiTPh-iMYsb6GMrnwAeA",
            name: "1.2 VX CVT",
            fuel_type: "petrol",
            cc: 1199,
            transmission_type: "automatic",
          },
          {
            id: "cz249L_fAym_Y1PpXiX_3g",
            name: "VX (O) I DTEC",
            fuel_type: "diesel",
            cc: 1498,
            transmission_type: "manual",
          },
          {
            id: "4Iccr7yZYrz-lnZ_6eyd6Q",
            name: "1.5 Vx (O) Mt (D) (1498 Cc)",
            fuel_type: "diesel",
            cc: 1498,
            transmission_type: "manual",
          },
          {
            id: "lpgOwo6CSdRJuN0b89bSlQ",
            name: "1.5 V I-Dtec (1498 Cc)",
            fuel_type: "diesel",
            cc: 1498,
            transmission_type: "manual",
          },
          {
            id: "3FUfa1Qhk-REUnHK0Q3KXg",
            name: "1.5 VX i-DTEC",
            fuel_type: "diesel",
            cc: 1498,
            transmission_type: "manual",
          },
          {
            id: "tviT4RRsIWclvoUiXd9YiQ",
            name: "1.2 VX AT i-VTEC",
            fuel_type: "petrol",
            cc: 1199,
            transmission_type: "automatic",
          },
          {
            id: "bz7xL9BlSoHwss5dcFzWZw",
            name: "1.2 VX i-VTEC",
            fuel_type: "petrol",
            cc: 1198,
            transmission_type: "manual",
          },
          {
            id: "KYbrgpTVL4dQx0-ExwVkkw",
            name: "1.2 V i - VTEC",
            fuel_type: "petrol",
            cc: 1199,
            transmission_type: "manual",
          },
          {
            id: "I6DAgSgAc1SrS_Iobu3RAw",
            name: "1.5 V AT i - DTEC",
            fuel_type: "diesel",
            cc: 1498,
            transmission_type: "automatic",
          },
          {
            id: "ezvypm8kXa-jMOtyzY1tBQ",
            name: "VX MT",
            fuel_type: "petrol",
            cc: 1199,
            transmission_type: "manual",
          },
          {
            id: "2cOT5DCsd7OaBvl1pFxpSA",
            name: "V MT",
            fuel_type: "diesel",
            cc: 1498,
            transmission_type: "manual",
          },
          {
            id: "hl31ZaaWB9xsSwt6BmvzHQ",
            name: "V CVT",
            fuel_type: "petrol",
            cc: 1199,
            transmission_type: "automatic",
          },
          {
            id: "CQIt8WCZFcmLxusW9WUtUg",
            name: "1.5 VX CVT",
            fuel_type: "diesel",
            cc: 1498,
            transmission_type: "automatic",
          },
          {
            id: "28UpEw7nLNf_6AvmYRqGig",
            name: "Exclusive Edition CVT",
            fuel_type: "diesel",
            cc: 1498,
            transmission_type: "automatic",
          },
          {
            id: "GBUXp9tgWhDNYGnQ9lkzBg",
            name: "Exclusive Edition CVT",
            fuel_type: "petrol",
            cc: 1199,
            transmission_type: "automatic",
          },
          {
            id: "KQWNs-9swQue0fbveV1IAg",
            name: "Elite Edition",
            fuel_type: "petrol",
            cc: 1199,
            transmission_type: "manual",
          },
          {
            id: "gi1xPk3NRmqGkjd820xhsg",
            name: "Elite Edition CVT",
            fuel_type: "petrol",
            cc: 1199,
            transmission_type: "automatic",
          },
          {
            id: "D1hAaMJtq8ywbdKvzd17Cw",
            name: "Pride Edition Diesel",
            fuel_type: "diesel",
            cc: 1498,
            transmission_type: "manual",
          },
          {
            id: "t9AcQR5yQxV3Ib8g37ArHw",
            name: "Pride Edition Petrol",
            fuel_type: "petrol",
            cc: 1198,
            transmission_type: "manual",
          },
          {
            id: "zji7iiet8SvPdH5G5Uwt5A",
            name: "1.2 V CVT Petrol",
            fuel_type: "petrol",
            cc: 1198,
            transmission_type: "automatic",
          },
          {
            id: "6COP1Amrk0RJZ9ieWY6MWw",
            name: "1.2 S AT i-VTEC",
            fuel_type: "petrol",
            cc: 1198,
            transmission_type: "automatic",
          },
          {
            id: "Lat5m3P0T4EL2U4TgKt-MA",
            name: "1.5 S i-DTEC",
            fuel_type: "diesel",
            cc: 1498,
            transmission_type: "manual",
          },
          {
            id: "226wRgCbU_zkILepO4XzNQ",
            name: "1.2 E I-VTEC OPT",
            fuel_type: "petrol",
            cc: 1198,
            transmission_type: "manual",
          },
          {
            id: "J-ScbVCxDER2UAF_YVlD-A",
            name: "1.2 S (O) Manual Transmission Petrol (1198 Cc)",
            fuel_type: "petrol",
            cc: 1198,
            transmission_type: "manual",
          },
          {
            id: "O-7yQOEAMf0uL25BSuBebg",
            name: "1.2 S AT I-VTEC OPT",
            fuel_type: "petrol",
            cc: 1198,
            transmission_type: "automatic",
          },
          {
            id: "5J5tqdeJQj7DNT3M2hYiUA",
            name: "1.2 S CVT",
            fuel_type: "petrol",
            cc: 1199,
            transmission_type: "automatic",
          },
          {
            id: "Iz4iRYOs9w9YZdPopwOsYQ",
            name: "1.2 S i-VTEC",
            fuel_type: "petrol",
            cc: 1198,
            transmission_type: "manual",
          },
          {
            id: "9RldxTm2PWwY20g1VE2VYw",
            name: "1.2 SX i-VTEC",
            fuel_type: "petrol",
            cc: 1198,
            transmission_type: "manual",
          },
          {
            id: "n5uxv4BbDOMvqiebQwRryg",
            name: "1.2 S i-VTEC Opt",
            fuel_type: "petrol",
            cc: 1198,
            transmission_type: "manual",
          },
          {
            id: "4LJfzA4kHptvkTBXBDOr7g",
            name: "1.5 E I-DTEC OPT",
            fuel_type: "diesel",
            cc: 1498,
            transmission_type: "manual",
          },
          {
            id: "-kXG74ZxIMKjKxlqDdkwZg",
            name: "1.5 S i-DTEC Opt",
            fuel_type: "diesel",
            cc: 1498,
            transmission_type: "manual",
          },
          {
            id: "ukk2hT5JfdNua4DF5fboew",
            name: "1.5 SX i-DTEC",
            fuel_type: "diesel",
            cc: 1498,
            transmission_type: "manual",
          },
          {
            id: "ctbAyGpHSvo9pDGzr2Hc9w",
            name: "1.5 SX MT",
            fuel_type: "diesel",
            cc: 1498,
            transmission_type: "manual",
          },
          {
            id: "zRgRcx3-b2mR7MBccqXOjg",
            name: "ACE Edition CVT",
            fuel_type: "petrol",
            cc: 1199,
            transmission_type: "automatic",
          },
          {
            id: "3RlaSspEvxEAziWhkwHZLw",
            name: "1.5 E MT",
            fuel_type: "diesel",
            cc: 1498,
            transmission_type: "manual",
          },
          {
            id: "vvUEICwtgiFNNHich0xprA",
            name: "1.5 S MT",
            fuel_type: "diesel",
            cc: 1498,
            transmission_type: "manual",
          },
          {
            id: "B5SVWs3DfeX9sUUyJ-SlyA",
            name: "1.2 S PLUS I-VTEC",
            fuel_type: "petrol",
            cc: 1198,
            transmission_type: "manual",
          },
          {
            id: "L0WLw9i7MvOWXiO1Gfleyw",
            name: "1.2 S MT Petrol Special Edition",
            fuel_type: "petrol",
            cc: 1199,
            transmission_type: "manual",
          },
          {
            id: "-ViUpY9m3OLC5kcIiSo6pg",
            name: "i-DTEC Privilege Edition",
            fuel_type: "diesel",
            cc: 1498,
            transmission_type: "manual",
          },
          {
            id: "wv_rXgdEDttSiZev4LUCiw",
            name: "i-VTEC Privilege Edition",
            fuel_type: "petrol",
            cc: 1198,
            transmission_type: "manual",
          },
          {
            id: "_2gGUls_pRERKbhzq3yiYw",
            name: "1.5 E i - DTEC",
            fuel_type: "petrol",
            cc: 1194,
            transmission_type: "manual",
          },
          {
            id: "qW-TDlsjEhFMS4UcXOZblQ",
            name: "1.5 S AT i - DTEC",
            fuel_type: "diesel",
            cc: 1498,
            transmission_type: "automatic",
          },
          {
            id: "QlEPOI1jhoZxvwwuxlHT6w",
            name: "S MT Petrol",
            fuel_type: "petrol",
            cc: 1199,
            transmission_type: "manual",
          },
          {
            id: "G9fZ5SQEi0hwY2ZSBCTMag",
            name: "E MT Petrol",
            fuel_type: "petrol",
            cc: 1199,
            transmission_type: "manual",
          },
          {
            id: "ER0n5-LFTEQ3ucQmphs4Iw",
            name: "1.2 S AT",
            fuel_type: "petrol",
            cc: 1198,
            transmission_type: "automatic",
          },
          {
            id: "w5XHyRpL3SpGkxRA-AStVg",
            name: "1.2 S MT",
            fuel_type: "petrol",
            cc: 1198,
            transmission_type: "manual",
          },
          {
            id: "nLtG_7D8vqXZQIyzDRmOrw",
            name: "S Plus",
            fuel_type: "internal_lpg_cng",
            cc: 1198,
            transmission_type: "manual",
          },
          {
            id: "Mr8IGz0t5DlE4nnkZNLwkA",
            name: "1.2 SX MT",
            fuel_type: "petrol",
            cc: 1198,
            transmission_type: "manual",
          },
          {
            id: "-Z1NpS6qsZLqxDy11xePpg",
            name: "Anniversary Edition",
            fuel_type: "diesel",
            cc: 1498,
            transmission_type: "manual",
          },
          {
            id: "YI8r_cg2RfADr8FYRZm06Q",
            name: "1.2 E MT",
            fuel_type: "petrol",
            cc: 1198,
            transmission_type: "manual",
          },
          {
            id: "-IltUyFi-1RmWCm8P1KV9Q",
            name: "ACE Edition CVT",
            fuel_type: "diesel",
            cc: 1498,
            transmission_type: "automatic",
          },
          {
            id: "otIuyAyhFBnKIDnOqvC4Wg",
            name: "ACE Edition",
            fuel_type: "diesel",
            cc: 1498,
            transmission_type: "manual",
          },
          {
            id: "W0NYl5GhPxG-gtsJzWUrJQ",
            name: "ACE Edition",
            fuel_type: "petrol",
            cc: 1199,
            transmission_type: "manual",
          },
          {
            id: "XcouC3gY98pBxquVmW5KcQ",
            name: "V CVT",
            fuel_type: "diesel",
            cc: 1498,
            transmission_type: "automatic",
          },
          {
            id: "vcgk0OLMYNMskrJIxF--eA",
            name: "V MT",
            fuel_type: "petrol",
            cc: 1199,
            transmission_type: "manual",
          },
          {
            id: "l1dKSyqzbayr9JbsTPE6RQ",
            name: "1.5 EX MT",
            fuel_type: "diesel",
            cc: 1498,
            transmission_type: "manual",
          },
          {
            id: "wuBEfSmS7hc5KmEb0v3YHA",
            name: "1.5 S CVT Special Edition",
            fuel_type: "diesel",
            cc: 1498,
            transmission_type: "automatic",
          },
          {
            id: "Rr1IOxKQt3r6AxHhCg25BQ",
            name: "1.5 S MT Special Edition",
            fuel_type: "diesel",
            cc: 1498,
            transmission_type: "manual",
          },
          {
            id: "BW0vprgeAElDPN_EqlKCkg",
            name: "1.2 S CVT Petrol Special Edition",
            fuel_type: "petrol",
            cc: 1199,
            transmission_type: "automatic",
          },
          {
            id: "wVkDLqtdYpnDY54jV8dW4w",
            name: "1.2 EX MT",
            fuel_type: "petrol",
            cc: 1198,
            transmission_type: "manual",
          },
          {
            id: "wbMORRK2ha2ztykDZ4ebrw",
            name: "1.2 CNG",
            fuel_type: "internal_lpg_cng",
            cc: 1198,
            transmission_type: "manual",
          },
          {
            id: "dNZR_a0N3QJ_Tn4F1io_tw",
            name: "1.2 E i-VTEC",
            fuel_type: "petrol",
            cc: 1198,
            transmission_type: "manual",
          },
        ],
      },
      {
        model_name: "WRV",
        variants: [
          {
            id: "TT1P_rcKEBI1DBdHCkpb5A",
            name: "I-DTEC VX",
            fuel_type: "diesel",
            cc: 1498,
            transmission_type: "manual",
          },
          {
            id: "OxtN2wZucafb3JL9zgF17Q",
            name: "I-VTEC VX",
            fuel_type: "petrol",
            cc: 1199,
            transmission_type: "manual",
          },
          {
            id: "hdz0c1i6QT7vFvtLw71zCQ",
            name: "1.2 Vx Mt (1199 Cc)",
            fuel_type: "petrol",
            cc: 1199,
            transmission_type: "manual",
          },
          {
            id: "KsaGXWB2GZEb7pv-ToMlXg",
            name: "1.5 Vx Mt (1498 Cc)",
            fuel_type: "diesel",
            cc: 1498,
            transmission_type: "manual",
          },
          {
            id: "Ap0W_yPhgpaehV48M2Qq6w",
            name: "V MT",
            fuel_type: "diesel",
            cc: 1498,
            transmission_type: "manual",
          },
          {
            id: "Z2gr2UG1IoS9H8T20OJJfQ",
            name: "1.5 S Mt (1498 Cc)",
            fuel_type: "diesel",
            cc: 1498,
            transmission_type: "manual",
          },
          {
            id: "I0y28odCINJoUYfbsEEIIA",
            name: "1.2 S Mt (1199 Cc)",
            fuel_type: "petrol",
            cc: 1199,
            transmission_type: "manual",
          },
          {
            id: "kUf7MxtOkZGGdiM5pR2QPQ",
            name: "S MT Alive Edition",
            fuel_type: "diesel",
            cc: 1498,
            transmission_type: "manual",
          },
          {
            id: "bqy0OE-6cXJB4nFbWgcx_g",
            name: "1.2 S MT-Alive",
            fuel_type: "petrol",
            cc: 1199,
            transmission_type: "manual",
          },
          {
            id: "XRt2GKwx2YwcV00F1d9czQ",
            name: "I-DTEC S",
            fuel_type: "diesel",
            cc: 1498,
            transmission_type: "manual",
          },
          {
            id: "f4kJ6le3UeeKqLIKM0jpUw",
            name: "I-VTEC S",
            fuel_type: "petrol",
            cc: 1199,
            transmission_type: "manual",
          },
          {
            id: "LeXqTlimp5SZH0S9QggLeg",
            name: "Exclusive Edition",
            fuel_type: "diesel",
            cc: 1498,
            transmission_type: "manual",
          },
          {
            id: "BsjE8BTjgUXBhmYOj2CX9A",
            name: "Exclusive Edition",
            fuel_type: "petrol",
            cc: 1199,
            transmission_type: "manual",
          },
          {
            id: "nA5SYnxSxkLLktKe2QvQdA",
            name: "SV MT",
            fuel_type: "diesel",
            cc: 1498,
            transmission_type: "manual",
          },
          {
            id: "GBGNcNW2t2Mq4oUNCM62kw",
            name: "1.2 SMT-EDGE",
            fuel_type: "petrol",
            cc: 1199,
            transmission_type: "manual",
          },
          {
            id: "FRTmD_0O-uBM3pLTBT1tdw",
            name: "SMT Edge Edition",
            fuel_type: "diesel",
            cc: 1498,
            transmission_type: "manual",
          },
          {
            id: "SNrX_IBYYhXYLmPpQG8x1Q",
            name: "SMT Edge Edition Diesel(Base Price)",
            fuel_type: "diesel",
            cc: 1498,
            transmission_type: "manual",
          },
          {
            id: "jyEsKhIh3lRPbhS8TKAhkQ",
            name: "SV MT",
            fuel_type: "petrol",
            cc: 1199,
            transmission_type: "manual",
          },
        ],
      },
      {
        model_name: "Accord",
        variants: [
          {
            id: "N0i8DgPtBYCW7Jo7p5E6AA",
            name: "Elegance AT",
            fuel_type: "petrol",
            cc: 2354,
            transmission_type: "automatic",
          },
          {
            id: "qIMIb-vCAFPS9Li5yK4OEg",
            name: "Inspire MT",
            fuel_type: "petrol",
            cc: 2354,
            transmission_type: "manual",
          },
          {
            id: "qaIu0Mlo7e3gYwUxPBwYAA",
            name: "2.3 VTI AT",
            fuel_type: "petrol",
            cc: 2254,
            transmission_type: "automatic",
          },
          {
            id: "WHNFlqYCg9VESpKUgkMCzg",
            name: "2.4 MT",
            fuel_type: "petrol",
            cc: 2354,
            transmission_type: "manual",
          },
          {
            id: "Mi0qKpTJuHxjBVkhgdbn_Q",
            name: "2.4 AT",
            fuel_type: "petrol",
            cc: 2354,
            transmission_type: "automatic",
          },
          {
            id: "j5scMMF44ad7QgeggB6YVg",
            name: "2.4 VTI L MT",
            fuel_type: "petrol",
            cc: 2354,
            transmission_type: "manual",
          },
          {
            id: "UEhQsFbfzEb6kKz7cJyj4A",
            name: "HYBRID",
            fuel_type: "petrol",
            cc: 1993,
            transmission_type: "manual",
          },
          {
            id: "Ysi7CuHz8eGCLktCVYE_SQ",
            name: "3.5 V6",
            fuel_type: "petrol",
            cc: 3471,
            transmission_type: "manual",
          },
          {
            id: "xvG1Z5cnpWyznFU8aOUV5A",
            name: "Elegance MT",
            fuel_type: "petrol",
            cc: 2354,
            transmission_type: "manual",
          },
          {
            id: "CTJ7mDhMDDgEOnsfWUdOjA",
            name: "Inspire AT",
            fuel_type: "petrol",
            cc: 2354,
            transmission_type: "automatic",
          },
          {
            id: "-lDf0xxfaAkg_-VX5cp3KA",
            name: "V6 Inspire",
            fuel_type: "petrol",
            cc: 3471,
            transmission_type: "manual",
          },
          {
            id: "jKUAaIkIZXQ4ETnE-iYKCQ",
            name: "Vti-L AT",
            fuel_type: "petrol",
            cc: 2354,
            transmission_type: "automatic",
          },
          {
            id: "_No9e0Emyay6LefS6NFCkA",
            name: "VTi-L MT",
            fuel_type: "petrol",
            cc: 2354,
            transmission_type: "manual",
          },
          {
            id: "gigQhe-De7VSNsjObFw9MQ",
            name: "V6 AT",
            fuel_type: "petrol",
            cc: 2997,
            transmission_type: "automatic",
          },
          {
            id: "T5i44BE4WXuA3IjJKV02hg",
            name: "1.8 MT",
            fuel_type: "petrol",
            cc: 1850,
            transmission_type: "manual",
          },
          {
            id: "Vmx4S46HxLR54nMUoM3mXQ",
            name: "2.3 VTI MT",
            fuel_type: "petrol",
            cc: 2254,
            transmission_type: "manual",
          },
          {
            id: "ljFQAVf1SLxWyXAs2ohVNQ",
            name: "1.6 AT",
            fuel_type: "petrol",
            cc: 1596,
            transmission_type: "automatic",
          },
        ],
      },
      {
        model_name: "Concerto",
        variants: [
          {
            id: "3lpAAs9Jlo9e6dWoZN6Qrw",
            name: "1.5 I",
            fuel_type: "petrol",
            cc: 1493,
            transmission_type: "manual",
          },
        ],
      },
      {
        model_name: "Integra",
        variants: [
          {
            id: "32YaAXBZCLV9dq97TkRTGg",
            name: "Standard",
            fuel_type: "petrol",
            cc: 1500,
            transmission_type: "manual",
          },
        ],
      },
      {
        model_name: "Odyssey",
        variants: [
          {
            id: "h4WJjWiY8tK2q4FBTDwJ4w",
            name: "EX",
            fuel_type: "petrol",
            cc: 2000,
            transmission_type: "manual",
          },
        ],
      },
      {
        model_name: "BR-V",
        variants: [
          {
            id: "aGXEDPSyxF0SZ0rDi8cm2w",
            name: "VX MT Style Edition",
            fuel_type: "diesel",
            cc: 1498,
            transmission_type: "manual",
          },
          {
            id: "Nl8AJkd9hZgCm9tRrVDXXQ",
            name: "V-Petrol (1497 Cc)",
            fuel_type: "petrol",
            cc: 1497,
            transmission_type: "manual",
          },
          {
            id: "eUjjqqiK2XG_in20Jqp1Mg",
            name: "i-VTEC V AT",
            fuel_type: "petrol",
            cc: 1497,
            transmission_type: "automatic",
          },
          {
            id: "MXhA7sSowm9kjKLdUvOByg",
            name: "i-VTEC V MT",
            fuel_type: "petrol",
            cc: 1497,
            transmission_type: "manual",
          },
          {
            id: "Vwt-EggzNoHQSXfMAkPbYQ",
            name: "i-VTEC VX MT",
            fuel_type: "petrol",
            cc: 1497,
            transmission_type: "manual",
          },
          {
            id: "cfdgd7W2AnIbBTuRgBquBw",
            name: "i-DTEC VX MT",
            fuel_type: "diesel",
            cc: 1498,
            transmission_type: "manual",
          },
          {
            id: "6xqdgjSanR5gUrXe4N-eAA",
            name: "i-DTEC V MT",
            fuel_type: "diesel",
            cc: 1498,
            transmission_type: "manual",
          },
          {
            id: "QXkHzghMGCOc7_h0_42Vyg",
            name: "i-VTEC V CVT",
            fuel_type: "petrol",
            cc: 1497,
            transmission_type: "automatic",
          },
          {
            id: "zxtAAap1CMNnK10ui-VlkQ",
            name: "V-Diesel (1498 Cc)",
            fuel_type: "diesel",
            cc: 1498,
            transmission_type: "manual",
          },
          {
            id: "LiPF1gQDKuS3QMKW650YSg",
            name: "VX CVT",
            fuel_type: "petrol",
            cc: 1497,
            transmission_type: "automatic",
          },
          {
            id: "yKfdxlY5m2g3Qa5GfFAkEg",
            name: "V CVT Style Edition",
            fuel_type: "petrol",
            cc: 1497,
            transmission_type: "automatic",
          },
          {
            id: "75XdMHcfw9_euayiPbma5Q",
            name: "V MT Style Edition",
            fuel_type: "petrol",
            cc: 1497,
            transmission_type: "manual",
          },
          {
            id: "gS7eoR6BlvZRgJ6U22thgQ",
            name: "VX MT Style Edition",
            fuel_type: "petrol",
            cc: 1497,
            transmission_type: "manual",
          },
          {
            id: "BJJQkZ4-BXtJcqw9dStsUQ",
            name: "V MT Style Edition",
            fuel_type: "diesel",
            cc: 1498,
            transmission_type: "manual",
          },
          {
            id: "VTsBmZ-qCBaQ-W7XT2eCTg",
            name: "V CVT Petrol Style Edition",
            fuel_type: "petrol",
            cc: 1498,
            transmission_type: "automatic",
          },
          {
            id: "N6dnqPojXgY95NEdqFHgXg",
            name: "S MT Style Edition",
            fuel_type: "petrol",
            cc: 1497,
            transmission_type: "manual",
          },
          {
            id: "SztPJR1ZVPug4rBoIU64og",
            name: "S MT Style Edition",
            fuel_type: "diesel",
            cc: 1498,
            transmission_type: "manual",
          },
          {
            id: "-bBkvab58m9tg29TTlr6DQ",
            name: "i-DTEC E MT",
            fuel_type: "diesel",
            cc: 1498,
            transmission_type: "manual",
          },
          {
            id: "sjODSHkwcCt2K4DctFC0YA",
            name: "i-VTEC S MT",
            fuel_type: "petrol",
            cc: 1497,
            transmission_type: "manual",
          },
          {
            id: "PTbwE8QXUoWUJ0exxPydrw",
            name: "i-DTEC S MT",
            fuel_type: "diesel",
            cc: 1498,
            transmission_type: "manual",
          },
          {
            id: "h2IyERtdBLekc0ko8IzM4g",
            name: "i-VTEC E MT",
            fuel_type: "petrol",
            cc: 1497,
            transmission_type: "manual",
          },
        ],
      },
      {
        model_name: "Brio",
        variants: [
          {
            id: "WLEnjpo7OfTOoowhLsVt0Q",
            name: "1.2 V MT",
            fuel_type: "petrol",
            cc: 1198,
            transmission_type: "manual",
          },
          {
            id: "GbElcTCiU4i3QW1J4VklXw",
            name: "1.2 V AT",
            fuel_type: "petrol",
            cc: 1198,
            transmission_type: "automatic",
          },
          {
            id: "jY9hUTsVy4DL_VsVJdK10Q",
            name: "1.2 Vx AT",
            fuel_type: "petrol",
            cc: 1198,
            transmission_type: "automatic",
          },
          {
            id: "CIYgLf-Uq9G1mV468O4-UQ",
            name: "VX (O) AT",
            fuel_type: "petrol",
            cc: 1198,
            transmission_type: "automatic",
          },
          {
            id: "eRETidXVL07pbwClmasAjg",
            name: "1.2 VX BL AT",
            fuel_type: "petrol",
            cc: 1198,
            transmission_type: "automatic",
          },
          {
            id: "4N91d3qdPsBc19crAQuXHQ",
            name: "VX (O) MT",
            fuel_type: "petrol",
            cc: 1198,
            transmission_type: "manual",
          },
          {
            id: "SUONJfg2MJSqNjKmFTx7tg",
            name: "1.2 VX BL MT",
            fuel_type: "petrol",
            cc: 1198,
            transmission_type: "manual",
          },
          {
            id: "wy_JuqeDTZv8q6GfDppn1w",
            name: "1.2 S Option MT",
            fuel_type: "petrol",
            cc: 1198,
            transmission_type: "manual",
          },
          {
            id: "_e5D9bfl54QI3h_OhlBiMg",
            name: "1.2 VX MT",
            fuel_type: "petrol",
            cc: 1198,
            transmission_type: "manual",
          },
          {
            id: "3rtt0wZc4sO47onEJcdjhg",
            name: "Exclusive Edition",
            fuel_type: "petrol",
            cc: 1198,
            transmission_type: "manual",
          },
          {
            id: "vp0Bpzi_q5sfUzvNB6aRww",
            name: "1.2 EX MT",
            fuel_type: "petrol",
            cc: 1198,
            transmission_type: "manual",
          },
          {
            id: "pqLyYWkp4qq885ukOmG_EA",
            name: "1.2 S Option AT",
            fuel_type: "petrol",
            cc: 1198,
            transmission_type: "automatic",
          },
          {
            id: "_eihQG9Zy0tCXk_s-Gfz9w",
            name: "1.2 S MT",
            fuel_type: "petrol",
            cc: 1198,
            transmission_type: "manual",
          },
          {
            id: "cTDWSrtUoaVtRv61s2CRpA",
            name: "1.2 E MT",
            fuel_type: "petrol",
            cc: 1198,
            transmission_type: "manual",
          },
        ],
      },
      {
        model_name: "Mobilio",
        variants: [
          {
            id: "xYViEbEGzjLuw3rc2R2eWg",
            name: "V(O)",
            fuel_type: "petrol",
            cc: 1497,
            transmission_type: "manual",
          },
          {
            id: "3t5MICQE2U9IFXa4YLlGaQ",
            name: "1.5 S",
            fuel_type: "diesel",
            cc: 1498,
            transmission_type: "manual",
          },
          {
            id: "4NSBI7r63L3agKwH6RHVWQ",
            name: "1.5 E",
            fuel_type: "diesel",
            cc: 1498,
            transmission_type: "manual",
          },
          {
            id: "t_9ECsFJ42xBKKz8IQj5ng",
            name: "1.5 S",
            fuel_type: "petrol",
            cc: 1497,
            transmission_type: "manual",
          },
          {
            id: "7P694tpKge3j98DyvQ8CWw",
            name: "1.5 E",
            fuel_type: "petrol",
            cc: 1497,
            transmission_type: "manual",
          },
          {
            id: "WSCuk9wKbyD1GdUdcMlbSA",
            name: "1.5 V",
            fuel_type: "petrol",
            cc: 1497,
            transmission_type: "manual",
          },
          {
            id: "sJXHM2pgvrlDSUlXkbhT_g",
            name: "1.5 RS",
            fuel_type: "diesel",
            cc: 1498,
            transmission_type: "manual",
          },
          {
            id: "goatWqgJJDS0Knl6IlN1og",
            name: "1.5 V",
            fuel_type: "diesel",
            cc: 1498,
            transmission_type: "manual",
          },
          {
            id: "lwB3405itTTy6zslpVv2Jw",
            name: "RS Option",
            fuel_type: "diesel",
            cc: 1498,
            transmission_type: "manual",
          },
          {
            id: "nwD2IAg5W2l263f9gIA2SQ",
            name: "V Option i DTEC",
            fuel_type: "diesel",
            cc: 1498,
            transmission_type: "manual",
          },
        ],
      },
      {
        model_name: "New City",
        variants: [
          {
            id: "NeqUrE_-YaAABTHNKwmuBg",
            name: "1.5 V AT",
            fuel_type: "petrol",
            cc: 1497,
            transmission_type: "automatic",
          },
          {
            id: "eFDLse_5rP84w80hP7klAw",
            name: "1.5 V MT",
            fuel_type: "petrol",
            cc: 1497,
            transmission_type: "manual",
          },
          {
            id: "WBIqrpi_EUtmXXMTZKF2_Q",
            name: "1.5 V MT Inspire",
            fuel_type: "petrol",
            cc: 1497,
            transmission_type: "manual",
          },
          {
            id: "lunoVXxxDao0Rt2Ka8LVvg",
            name: "1.5 VX AT",
            fuel_type: "petrol",
            cc: 1497,
            transmission_type: "automatic",
          },
          {
            id: "0lUC0P91PHTUiv-_pSocnA",
            name: "1.5 V MT",
            fuel_type: "diesel",
            cc: 1498,
            transmission_type: "manual",
          },
          {
            id: "zT9eNmM3Z3SczIf8-45HVw",
            name: "1.5 VX MT",
            fuel_type: "petrol",
            cc: 1497,
            transmission_type: "manual",
          },
          {
            id: "a1o04BYdaet_yHr-fKuzIw",
            name: "1.5 VX MT",
            fuel_type: "diesel",
            cc: 1498,
            transmission_type: "manual",
          },
          {
            id: "mmt5h-SvIm0vFIA7YVgkSg",
            name: "VX MT (O)",
            fuel_type: "petrol",
            cc: 1497,
            transmission_type: "manual",
          },
          {
            id: "O6QZrs6JK54dXJiuNQaX8A",
            name: "ZX CVT",
            fuel_type: "petrol",
            cc: 1497,
            transmission_type: "automatic",
          },
          {
            id: "dGwTfMgdaHu8WphSZJ1IDg",
            name: "ZX MT",
            fuel_type: "diesel",
            cc: 1498,
            transmission_type: "manual",
          },
          {
            id: "RiXYJDt_kERg4adSId4pcQ",
            name: "1.5 V Auto Transmission Sunroof (1497 Cc)",
            fuel_type: "petrol",
            cc: 1497,
            transmission_type: "automatic",
          },
          {
            id: "QkmDIRdJQgHJuw0brVuXTQ",
            name: "1.5 V L Manual Transmission Avn (1497 Cc)",
            fuel_type: "petrol",
            cc: 1497,
            transmission_type: "manual",
          },
          {
            id: "JJTmpFz2jDgzrj-CPngiCA",
            name: "1.5 V Manual Transmission Avn (1497 Cc)",
            fuel_type: "petrol",
            cc: 1497,
            transmission_type: "manual",
          },
          {
            id: "HeDcflDJrHhimhzfajmv0A",
            name: "1.5 V Manual Transmission Cng (1497 Cc)",
            fuel_type: "internal_lpg_cng",
            cc: 1497,
            transmission_type: "manual",
          },
          {
            id: "EQTAThJlv_Ju7NeXAqBtMg",
            name: "1.5 V Manual Transmission Sunroof (1497 Cc)",
            fuel_type: "petrol",
            cc: 1497,
            transmission_type: "manual",
          },
          {
            id: "GXyy8UukjZYFUCOZ4SNjxg",
            name: "Elegant Edition",
            fuel_type: "petrol",
            cc: 1498,
            transmission_type: "manual",
          },
          {
            id: "Jf7GkfMrDE3GCZKeh-ZA-g",
            name: "Elegant Edition CVT",
            fuel_type: "petrol",
            cc: 1498,
            transmission_type: "automatic",
          },
          {
            id: "vLe3uvJMvqTXQNdAMa7ZYQ",
            name: "V eHEV",
            fuel_type: "petrol",
            cc: 1498,
            transmission_type: "automatic",
          },
          {
            id: "vreUFPBuNxbvBSApa0IbBA",
            name: "ZX eHEV",
            fuel_type: "petrol",
            cc: 1498,
            transmission_type: "automatic",
          },
          {
            id: "QbmuT1QamRO2cs_Tn2bZUg",
            name: "SV CVT",
            fuel_type: "petrol",
            cc: 1497,
            transmission_type: "automatic",
          },
          {
            id: "NO9fQBkVjxLdl4OW14DJnw",
            name: "SV MT Edge Edition",
            fuel_type: "petrol",
            cc: 1497,
            transmission_type: "manual",
          },
          {
            id: "u_e810to2CSNoSfvSs4Y9w",
            name: "SV MT Edge Edition",
            fuel_type: "diesel",
            cc: 1498,
            transmission_type: "manual",
          },
          {
            id: "6nIFD7kO3Fek7XXR48jCFg",
            name: "20th Anniversary Edition CVT",
            fuel_type: "petrol",
            cc: 1497,
            transmission_type: "automatic",
          },
          {
            id: "Wq7ojqud30UPdrFlm-i7kQ",
            name: "20th Anniversary Edition MT",
            fuel_type: "diesel",
            cc: 1498,
            transmission_type: "manual",
          },
          {
            id: "hMVDuyRBpLEC16LKuhAUwQ",
            name: "1.5 SV AT",
            fuel_type: "petrol",
            cc: 1497,
            transmission_type: "automatic",
          },
          {
            id: "ji7PhqgF8LtQZ-v_VO2IzA",
            name: "1.5 SV MT",
            fuel_type: "diesel",
            cc: 1498,
            transmission_type: "manual",
          },
          {
            id: "L5u-isNHHLNcqsMtnSl4tw",
            name: "1.5 Corporate Edition",
            fuel_type: "petrol",
            cc: 1497,
            transmission_type: "manual",
          },
          {
            id: "kRpfU2l0E62h47aE1oHocA",
            name: "1.5 S MT",
            fuel_type: "petrol",
            cc: 1497,
            transmission_type: "manual",
          },
          {
            id: "SZMUv_YEVejKc_P3xN6erQ",
            name: "1.5 S AT",
            fuel_type: "petrol",
            cc: 1497,
            transmission_type: "automatic",
          },
          {
            id: "7dnc25y6A2geiTYjYS6nhQ",
            name: "1.5 S MT",
            fuel_type: "diesel",
            cc: 1498,
            transmission_type: "manual",
          },
          {
            id: "2LceZX3SPwUGva2gbueAKA",
            name: "1.5 E MT",
            fuel_type: "diesel",
            cc: 1498,
            transmission_type: "manual",
          },
          {
            id: "ZqoO9CgLYow8pdJqzSlUmQ",
            name: "1.5 SV MT",
            fuel_type: "petrol",
            cc: 1497,
            transmission_type: "manual",
          },
          {
            id: "0Psi-xIm0GNr3M9rcz_RYg",
            name: "1.5 E MT",
            fuel_type: "petrol",
            cc: 1497,
            transmission_type: "manual",
          },
          {
            id: "RKJyL3bZwpa1shKI3rHEVw",
            name: "1.5 V AT Inspire",
            fuel_type: "petrol",
            cc: 1497,
            transmission_type: "automatic",
          },
        ],
      },
      {
        model_name: "Civic",
        variants: [
          {
            id: "ORR9ZL1c2Nnif8W54xaloQ",
            name: "1.8 V AT Elegance",
            fuel_type: "petrol",
            cc: 1799,
            transmission_type: "automatic",
          },
          {
            id: "HQRpfEMa3Ii8CgP560lCWg",
            name: "1.8 V AT Inspire",
            fuel_type: "petrol",
            cc: 1799,
            transmission_type: "automatic",
          },
          {
            id: "J1JYMJDaEopiqS-uIchksA",
            name: "1.8 E MT",
            fuel_type: "petrol",
            cc: 1799,
            transmission_type: "manual",
          },
          {
            id: "bPCBRne_B001ZMeovWJAFA",
            name: "1.8 V MT",
            fuel_type: "petrol",
            cc: 1799,
            transmission_type: "manual",
          },
          {
            id: "fTwSkRd7Uo7Wr6YBtwmFpw",
            name: "1.8 V AT SUNROOF",
            fuel_type: "petrol",
            cc: 1799,
            transmission_type: "automatic",
          },
          {
            id: "z3o-ZG6b-k8B_DBUrA73hw",
            name: "1.8 V MT SUNROOF",
            fuel_type: "petrol",
            cc: 1799,
            transmission_type: "manual",
          },
          {
            id: "Oxx0zwzOlleEErJ0WOA88g",
            name: "Hybrid",
            fuel_type: "petrol",
            cc: 1339,
            transmission_type: "manual",
          },
          {
            id: "g1NWGdbBqdoxPeSkRelgwQ",
            name: "1.8 S MT",
            fuel_type: "petrol",
            cc: 1799,
            transmission_type: "manual",
          },
          {
            id: "vMIIm804inAbYzEuqkn11w",
            name: "1.8 S AT",
            fuel_type: "petrol",
            cc: 1799,
            transmission_type: "automatic",
          },
          {
            id: "ukdUSYMyEeJLdYCkmjne0w",
            name: "ZX CVT",
            fuel_type: "petrol",
            cc: 1799,
            transmission_type: "automatic",
          },
          {
            id: "QNM2rRohWtBpGAeNdEAuqg",
            name: "V CVT",
            fuel_type: "petrol",
            cc: 1799,
            transmission_type: "automatic",
          },
          {
            id: "0G_zheLd17aRdL62QdQeOQ",
            name: "VX CVT",
            fuel_type: "petrol",
            cc: 1799,
            transmission_type: "automatic",
          },
          {
            id: "slNAMjyy6wbOeQi0VihG5w",
            name: "1.8 S MT Elegance",
            fuel_type: "petrol",
            cc: 1799,
            transmission_type: "manual",
          },
          {
            id: "_Axg-gf0oAIHYskoK5vDlg",
            name: "1.8 S MT Inspire",
            fuel_type: "petrol",
            cc: 1799,
            transmission_type: "manual",
          },
          {
            id: "Rm3rUvgcViwQ1grj9Uu5PA",
            name: "1.8 V MT Elegance",
            fuel_type: "petrol",
            cc: 1799,
            transmission_type: "manual",
          },
          {
            id: "FjilSPAKaFvQVuKf_tlyng",
            name: "1.8 V AT",
            fuel_type: "petrol",
            cc: 1799,
            transmission_type: "automatic",
          },
          {
            id: "YsHGnZYwyafwp4sC-OdqxA",
            name: "Sport",
            fuel_type: "petrol",
            cc: 1799,
            transmission_type: "manual",
          },
          {
            id: "kM_2C5R-Or7joLlXqu-GkQ",
            name: "1.8 V MT Inspire",
            fuel_type: "petrol",
            cc: 1799,
            transmission_type: "manual",
          },
          {
            id: "Y6W5xXeJjFAYHevd_-2VXQ",
            name: "VX",
            fuel_type: "diesel",
            cc: 1597,
            transmission_type: "manual",
          },
          {
            id: "n9MFCoRw0mkIWtJpnauaCQ",
            name: "ZX",
            fuel_type: "diesel",
            cc: 1597,
            transmission_type: "manual",
          },
          {
            id: "Vhy9YGjcxyp3pkkh5dcCow",
            name: "1.5 L",
            fuel_type: "petrol",
            cc: 1493,
            transmission_type: "manual",
          },
        ],
      },
      {
        model_name: "City ZX",
        variants: [
          {
            id: "I-o0Rh_RskuhIbhyQ4x_ZA",
            name: "CVT",
            fuel_type: "petrol",
            cc: 1497,
            transmission_type: "automatic",
          },
          {
            id: "YTExNeiBXcrVYIvJVlssYQ",
            name: "Vtec",
            fuel_type: "petrol",
            cc: 1497,
            transmission_type: "manual",
          },
          {
            id: "nnoCfRmdo9w0fCc_pwzeiw",
            name: "Vtec Plus",
            fuel_type: "petrol",
            cc: 1497,
            transmission_type: "manual",
          },
          {
            id: "2U-vIDIHIODUmDWB_Z34nQ",
            name: "1.5 GXI CVT",
            fuel_type: "petrol",
            cc: 1497,
            transmission_type: "automatic",
          },
          {
            id: "WcYSDgqs4ni1RB-gHHbbCg",
            name: "EXI",
            fuel_type: "petrol",
            cc: 1497,
            transmission_type: "manual",
          },
          {
            id: "9KOpd1ed0D_EGFS0wymlqw",
            name: "GXI",
            fuel_type: "petrol",
            cc: 1497,
            transmission_type: "manual",
          },
        ],
      },
      {
        model_name: "Civic Hybrid",
        variants: [
          {
            id: "MavhnyVawwlXCHWrMj1G3Q",
            name: "1.3 I-Vtec",
            fuel_type: "petrol",
            cc: 1300,
            transmission_type: "manual",
          },
        ],
      },
      {
        model_name: "CRV",
        variants: [
          {
            id: "stNTmO2kRJgwjYjGqVdRlw",
            name: "2.4L 2WD",
            fuel_type: "petrol",
            cc: 2354,
            transmission_type: "manual",
          },
          {
            id: "Cr3NVEY47WYjPcj4fsZwdg",
            name: "2.0 MT",
            fuel_type: "petrol",
            cc: 1997,
            transmission_type: "manual",
          },
          {
            id: "VlTXs4RYc4qlpOoD9q6ruw",
            name: "2.4 4WD AT SUNROOF",
            fuel_type: "petrol",
            cc: 2354,
            transmission_type: "automatic",
          },
          {
            id: "J9LedHLC2lGONMneYewbRA",
            name: "2.4 4WD MT SUNROOF",
            fuel_type: "petrol",
            cc: 2354,
            transmission_type: "manual",
          },
          {
            id: "yql73G6zHdax8jPRgitt9A",
            name: "2.4 RVI AT",
            fuel_type: "petrol",
            cc: 2354,
            transmission_type: "automatic",
          },
          {
            id: "34vWtPv6DIE-QW2HC-Y8rg",
            name: "2.4 RVSI AT",
            fuel_type: "petrol",
            cc: 2354,
            transmission_type: "automatic",
          },
          {
            id: "XgEmeF1GXEwvh_GeRU13Jg",
            name: "2.0 RVI AT",
            fuel_type: "petrol",
            cc: 1995,
            transmission_type: "automatic",
          },
          {
            id: "FhylyOtrBl47lyqX_Sbqpw",
            name: "2.0 RVI MT",
            fuel_type: "petrol",
            cc: 1995,
            transmission_type: "manual",
          },
          {
            id: "Rkhe_AslKe_UuK8-LQEbrw",
            name: "2.0 2WD",
            fuel_type: "petrol",
            cc: 1997,
            transmission_type: "manual",
          },
          {
            id: "E0x3XT6H9TkD4X6CdRMWTg",
            name: "2.4 4WD AT",
            fuel_type: "petrol",
            cc: 2354,
            transmission_type: "automatic",
          },
          {
            id: "JzzTcteSoiNk7gLORgutRg",
            name: "2.4 4WD MT",
            fuel_type: "petrol",
            cc: 2354,
            transmission_type: "manual",
          },
          {
            id: "RfmU33LI_r9NHfefD4GFKA",
            name: "2.4 RVSI MT",
            fuel_type: "petrol",
            cc: 2354,
            transmission_type: "manual",
          },
          {
            id: "X39c0pBMMwKDrub45ISOfg",
            name: "2WD Pertol CVT",
            fuel_type: "petrol",
            cc: 1997,
            transmission_type: "automatic",
          },
          {
            id: "o4UPHGRCqS78Wv9Jyq8Spw",
            name: "2WD Diesel AT",
            fuel_type: "diesel",
            cc: 1597,
            transmission_type: "automatic",
          },
          {
            id: "pe586QBHPJQ3AMGK88JQiw",
            name: "1.6 (AWD 9AT)",
            fuel_type: "diesel",
            cc: 1597,
            transmission_type: "automatic",
          },
          {
            id: "ayudTNqiu2pU33nus2_RMg",
            name: "2.0 (A/T)",
            fuel_type: "petrol",
            cc: 1997,
            transmission_type: "automatic",
          },
          {
            id: "thW6in-fH-KUM-YtNXBb2w",
            name: "2.0 CVT",
            fuel_type: "petrol",
            cc: 1997,
            transmission_type: "automatic",
          },
          {
            id: "ofgtO5deqWXNpTRsRyMLiQ",
            name: "2.4 (A/T)(Smart Entry)",
            fuel_type: "petrol",
            cc: 2354,
            transmission_type: "automatic",
          },
          {
            id: "feO7j5_L65niEKsbUmmgyQ",
            name: "1.6 (9AT)",
            fuel_type: "diesel",
            cc: 1597,
            transmission_type: "automatic",
          },
          {
            id: "g6AF6tOaOpgYMWrmaT_6pQ",
            name: "Special Edition",
            fuel_type: "petrol",
            cc: 1997,
            transmission_type: "automatic",
          },
          {
            id: "F5rFZkPGybKEdc4vddHkfw",
            name: "2.0 AT",
            fuel_type: "petrol",
            cc: 1997,
            transmission_type: "automatic",
          },
          {
            id: "Q9jheWKvtZJE8ThJbBahTw",
            name: "2.4 AT",
            fuel_type: "petrol",
            cc: 2354,
            transmission_type: "automatic",
          },
          {
            id: "7LxMpQRu9AwKotWTJkxrtQ",
            name: "2.4 AT AVN",
            fuel_type: "petrol",
            cc: 2354,
            transmission_type: "automatic",
          },
          {
            id: "219n7dHLchHIZgeSzKq1rw",
            name: "Base",
            fuel_type: "diesel",
            cc: 2000,
            transmission_type: "manual",
          },
          {
            id: "D4_rdjcwcgiw9ew3YxU0Ng",
            name: "Sun Roof AT",
            fuel_type: "petrol",
            cc: 1198,
            transmission_type: "automatic",
          },
          {
            id: "RfHD9aQ3sZBH0lwWIlqbWw",
            name: "AWD Diesel AT",
            fuel_type: "diesel",
            cc: 1597,
            transmission_type: "automatic",
          },
          {
            id: "CXyyo-nuCgUd1XADiVYY1Q",
            name: "2.0 2WD AT",
            fuel_type: "petrol",
            cc: 1997,
            transmission_type: "automatic",
          },
          {
            id: "dEoTlIRKybUjVX8Q_95q7g",
            name: "2.4L 4Wd Auto Transmission Avn (2354 Cc)",
            fuel_type: "petrol",
            cc: 2354,
            transmission_type: "automatic",
          },
          {
            id: "Q4p4tPDyG1rGWyAl9vAxwQ",
            name: "2.4 RVI MT",
            fuel_type: "petrol",
            cc: 2354,
            transmission_type: "manual",
          },
        ],
      },
      {
        model_name: "ACCORD VTI",
        variants: [
          {
            id: "MNBFynkAJHBfAgbyALgJGg",
            name: "3.0 V6",
            fuel_type: "petrol",
            cc: 2997,
            transmission_type: "manual",
          },
        ],
      },
      {
        model_name: "Elevate",
        variants: [
          {
            id: "NY_MedxMcgrCtEMQDDL2Gw",
            name: "SV",
            fuel_type: "petrol",
            cc: 1498,
            transmission_type: "manual",
          },
          {
            id: "YgY6mFgjoESxRt9QVxTY7w",
            name: "V",
            fuel_type: "petrol",
            cc: 1498,
            transmission_type: "manual",
          },
          {
            id: "KiQdztK_FsUk29j-6sSEbg",
            name: "V CVT",
            fuel_type: "petrol",
            cc: 1498,
            transmission_type: "automatic",
          },
          {
            id: "E1hlHVzrhfwh7b3JYd0n8A",
            name: "VX",
            fuel_type: "petrol",
            cc: 1498,
            transmission_type: "manual",
          },
          {
            id: "f0KevAX1BwByBUfRq4ikgw",
            name: "VX CVT",
            fuel_type: "petrol",
            cc: 1498,
            transmission_type: "automatic",
          },
          {
            id: "J_r_Ft1zl7CViTfJk7vMTg",
            name: "ZX",
            fuel_type: "petrol",
            cc: 1498,
            transmission_type: "manual",
          },
          {
            id: "LBmrr5w6dYr7IDg13mut0A",
            name: "ZX CVT",
            fuel_type: "petrol",
            cc: 1498,
            transmission_type: "automatic",
          },
          {
            id: "SFCIepF-WO99kDT1H3_SNA",
            name: "ZX CVT Dual Tone",
            fuel_type: "petrol",
            cc: 1498,
            transmission_type: "automatic",
          },
        ],
      },
    ],
  }
}
    
export const SAMPLE_POPULAR_VEHICLE_DATA = [
  {
    id: "Ym1iJ1FqFMMrlOuF2o95Wg",
    name: "Tata Nexon [2020-2023]",
    variants: [
      {
        id: "SD_uLoBlxoXWxr3ctWGG6Q",
        name: "1.2",
        fuel_type: "petrol",
        cc: 1198,
        transmission_type: "manual",
        is_popular: true,
      },
      {
        id: "kbUC-dq97QBQ1qKX7DvF-Q",
        name: "XE",
        fuel_type: "petrol",
        cc: 1198,
        transmission_type: "manual",
        is_popular: true,
      },
      {
        id: "jzajGyS9-L6HGZhSsQsAAw",
        name: "1.2 Revotron XE",
        fuel_type: "petrol",
        cc: 1198,
        transmission_type: "manual",
        is_popular: true,
      },
      {
        id: "nz0kxuoEcC66vNV3hytLMQ",
        name: "KRAZ",
        fuel_type: "petrol",
        cc: 1198,
        transmission_type: "manual",
        is_popular: true,
      },
      {
        id: "om-LSMnEaYV33iaowM7snw",
        name: "1.5",
        fuel_type: "diesel",
        cc: 1497,
        transmission_type: "manual",
        is_popular: true,
      },
      {
        id: "Pd_eftropelmRxF68GYmBg",
        name: "1.2 XE",
        fuel_type: "petrol",
        cc: 1199,
        transmission_type: "manual",
        is_popular: true,
      },
      {
        id: "pfHnWH4y-Qsfz_J3LBWN9Q",
        name: "1.2 Revotron XM",
        fuel_type: "petrol",
        cc: 1198,
        transmission_type: "manual",
        is_popular: true,
      },
      {
        id: "FCHK4G1VmZGIgCZNflk7Qw",
        name: "Revotron XTA",
        fuel_type: "petrol",
        cc: 1198,
        transmission_type: "automatic",
        is_popular: true,
      },
      {
        id: "AUUfflVBAE6E3SB5r6td6A",
        name: "KRAZ Plus",
        fuel_type: "petrol",
        cc: 1198,
        transmission_type: "manual",
        is_popular: true,
      },
      {
        id: "peN1ncyeRGKHo6D5BON-Sw",
        name: "XE",
        fuel_type: "diesel",
        cc: 1497,
        transmission_type: "manual",
        is_popular: true,
      },
      {
        id: "IrdlAgrki8DYGSB7LwHSNg",
        name: "1.2 Revotron XT",
        fuel_type: "petrol",
        cc: 1198,
        transmission_type: "manual",
        is_popular: true,
      },
      {
        id: "HOgLO2bZHdPtJiCMYMDaFQ",
        name: "XT",
        fuel_type: "petrol",
        cc: 1198,
        transmission_type: "manual",
        is_popular: true,
      },
      {
        id: "Jr2Iw54XWMx43uN_gjebiQ",
        name: "XMA",
        fuel_type: "petrol",
        cc: 1198,
        transmission_type: "automatic",
        is_popular: true,
      },
      {
        id: "du02HO3L0prusJ0IdV4jtQ",
        name: "1.2 Revotron XT Plus",
        fuel_type: "petrol",
        cc: 1198,
        transmission_type: "manual",
        is_popular: true,
      },
      {
        id: "PAaCc1CDvesUlsCJ2W2dYA",
        name: "XT Plus",
        fuel_type: "petrol",
        cc: 1198,
        transmission_type: "manual",
        is_popular: true,
      },
      {
        id: "bqdPLo-jKXY9gj6lc4pYVA",
        name: "Kraz Plus Amt",
        fuel_type: "petrol",
        cc: 1198,
        transmission_type: "automatic",
        is_popular: true,
      },
      {
        id: "jX0EkOBN4gK0u-PxbiyYgg",
        name: "Kraz Plus Amt",
        fuel_type: "diesel",
        cc: 1497,
        transmission_type: "automatic",
        is_popular: true,
      },
      {
        id: "-7McgAgGOfJmQKkrjA8CkQ",
        name: "1.5 Revotorq XE",
        fuel_type: "diesel",
        cc: 1497,
        transmission_type: "manual",
        is_popular: true,
      },
      {
        id: "QuWeMHmLHLXEdhjhlVkXSA",
        name: "1.2 XM",
        fuel_type: "petrol",
        cc: 1199,
        transmission_type: "manual",
        is_popular: true,
      },
      {
        id: "_bqjcdAyPVPz1Kr_i1YfaA",
        name: "XM",
        fuel_type: "diesel",
        cc: 1497,
        transmission_type: "manual",
        is_popular: true,
      },
      {
        id: "SVgl1cDsdW6kg0IyYglgNw",
        name: "KRAZ",
        fuel_type: "diesel",
        cc: 1497,
        transmission_type: "manual",
        is_popular: true,
      },
      {
        id: "JapFYSLjqTClGCqZtuBsMw",
        name: "XM",
        fuel_type: "petrol",
        cc: 1198,
        transmission_type: "manual",
        is_popular: true,
      },
      {
        id: "geSnOQ4yVaj8ZzmqWpEjGA",
        name: "KRAZ Plus",
        fuel_type: "diesel",
        cc: 1497,
        transmission_type: "manual",
        is_popular: true,
      },
      {
        id: "fgksoqmCfyLugCq7u6SMuQ",
        name: "1.5 Revotorq XM",
        fuel_type: "diesel",
        cc: 1497,
        transmission_type: "manual",
        is_popular: true,
      },
      {
        id: "Tcoi0xotbq3VGcgsfapm7A",
        name: "1.5 Revotorq XT",
        fuel_type: "diesel",
        cc: 1497,
        transmission_type: "manual",
        is_popular: true,
      },
      {
        id: "N1ka1ENqt3kFBb0NnwbmVA",
        name: "1.5 Revotorq XT Plus",
        fuel_type: "diesel",
        cc: 1497,
        transmission_type: "manual",
        is_popular: true,
      },
      {
        id: "QQ1gDF00Rsc3ACl9fmbAOg",
        name: "XT",
        fuel_type: "diesel",
        cc: 1497,
        transmission_type: "manual",
        is_popular: true,
      },
      {
        id: "PlC1jWItav-qdtP_Qdhz3A",
        name: "1.2 XM S",
        fuel_type: "petrol",
        cc: 1199,
        transmission_type: "manual",
        is_popular: true,
      },
      {
        id: "bneVpN0KCLzOZS-oIg_KSw",
        name: "1.2 XMA",
        fuel_type: "petrol",
        cc: 1199,
        transmission_type: "automatic",
        is_popular: true,
      },
      {
        id: "COTFoJR7ZZxAV6-y3S3IZA",
        name: "1.2 XZ Plus",
        fuel_type: "petrol",
        cc: 1199,
        transmission_type: "manual",
        is_popular: true,
      },
      {
        id: "Nw69SRFcmIG9MYh5dVVuEA",
        name: "1.2 Revotron XZ Plus",
        fuel_type: "petrol",
        cc: 1198,
        transmission_type: "manual",
        is_popular: true,
      },
      {
        id: "_zJ5HyLpipeUma1RIp0W6w",
        name: "XZ Plus",
        fuel_type: "petrol",
        cc: 1198,
        transmission_type: "manual",
        is_popular: true,
      },
      {
        id: "IjBmgq2Ef1Y8liiJHQeIuQ",
        name: "1.2 XZ",
        fuel_type: "petrol",
        cc: 1199,
        transmission_type: "manual",
        is_popular: true,
      },
      {
        id: "TgJToLjfS4a7m4qzWpag1w",
        name: "XZ",
        fuel_type: "petrol",
        cc: 1198,
        transmission_type: "manual",
        is_popular: true,
      },
      {
        id: "3y3nHmJhi12PPgyhGpn6iA",
        name: "1.2 Revotron XZ Plus Dual Tone",
        fuel_type: "petrol",
        cc: 1198,
        transmission_type: "manual",
        is_popular: true,
      },
      {
        id: "zD_jbs8QBsQ2-cwkxd9nwg",
        name: "XZ Plus Dual Tone",
        fuel_type: "petrol",
        cc: 1198,
        transmission_type: "manual",
        is_popular: true,
      },
      {
        id: "WYy6u00ELoVJshqZbP7r6Q",
        name: "1.2 XM Plus S",
        fuel_type: "petrol",
        cc: 1199,
        transmission_type: "manual",
        is_popular: true,
      },
      {
        id: "SMPEC0VsFXrQhda1fQhk9w",
        name: "1.2 XMA S",
        fuel_type: "petrol",
        cc: 1199,
        transmission_type: "automatic",
        is_popular: true,
      },
      {
        id: "5i1eBROibF7eXhohegFKQw",
        name: "XZA Plus",
        fuel_type: "petrol",
        cc: 1198,
        transmission_type: "automatic",
        is_popular: true,
      },
      {
        id: "GOlyws9_blJ2mQ3zFmFYlA",
        name: "XMA",
        fuel_type: "diesel",
        cc: 1497,
        transmission_type: "automatic",
        is_popular: true,
      },
      {
        id: "h894ti-_OHRU4YIp-9iYvg",
        name: "XZA Plus Dual Tone",
        fuel_type: "petrol",
        cc: 1198,
        transmission_type: "automatic",
        is_popular: true,
      },
      {
        id: "ThopQSrcZS40kxOXc0ag-g",
        name: "1.5 XMA Plus S",
        fuel_type: "diesel",
        cc: 1497,
        transmission_type: "automatic",
        is_popular: true,
      },
      {
        id: "tnsyiYJUUFtGNpq-TP0INQ",
        name: "1.2 XMA Plus S",
        fuel_type: "petrol",
        cc: 1199,
        transmission_type: "automatic",
        is_popular: true,
      },
      {
        id: "Alo8VTLCex2ZeZGf07QTQA",
        name: "XZ Plus",
        fuel_type: "diesel",
        cc: 1497,
        transmission_type: "manual",
        is_popular: true,
      },
      {
        id: "T_9tSpU5UrW9_7SDLbNa_g",
        name: "1.5 XM S",
        fuel_type: "diesel",
        cc: 1497,
        transmission_type: "manual",
        is_popular: true,
      },
      {
        id: "VNu189YMx3BGrWOZcNBLfw",
        name: "1.2 XZ Plus Dark Edition",
        fuel_type: "petrol",
        cc: 1199,
        transmission_type: "manual",
        is_popular: true,
      },
      {
        id: "JdDeSzXcZGUMYa6bPJuRWA",
        name: "XZ",
        fuel_type: "diesel",
        cc: 1497,
        transmission_type: "manual",
        is_popular: true,
      },
      {
        id: "s965pIcKl4d4b7ChlgBnCA",
        name: "XZ Plus Dual Tone",
        fuel_type: "diesel",
        cc: 1497,
        transmission_type: "manual",
        is_popular: true,
      },
      {
        id: "T6LOph1G1bkB_w1uDT5i1A",
        name: "1.2 XZ Plus (S)",
        fuel_type: "petrol",
        cc: 1199,
        transmission_type: "manual",
        is_popular: true,
      },
      {
        id: "Zhi6pkOnFzongF8tecRBVA",
        name: "1.5 Revotorq XZ Plus",
        fuel_type: "diesel",
        cc: 1497,
        transmission_type: "manual",
        is_popular: true,
      },
      {
        id: "AIRyqCO-2ArFVtxV5w7P4g",
        name: "1.2 XZ Plus HS",
        fuel_type: "petrol",
        cc: 1199,
        transmission_type: "manual",
        is_popular: true,
      },
      {
        id: "6qWMjaStyO7YvdExrRXCAA",
        name: "1.5 XM Plus S",
        fuel_type: "diesel",
        cc: 1497,
        transmission_type: "manual",
        is_popular: true,
      },
      {
        id: "RmVYUxwMEFEUM5eUC5HDmA",
        name: "1.5 XZ PLUS DUAL TONE",
        fuel_type: "diesel",
        cc: 1497,
        transmission_type: "manual",
        is_popular: true,
      },
      {
        id: "9H-L8ijwyivNbgmm0Kt0Dg",
        name: "XZA Plus Option Dual Tone",
        fuel_type: "petrol",
        cc: 1199,
        transmission_type: "automatic",
        is_popular: true,
      },
      {
        id: "b82efY3Kq-Hpt3qO8v4zDQ",
        name: "XZA Plus",
        fuel_type: "diesel",
        cc: 1497,
        transmission_type: "automatic",
        is_popular: true,
      },
      {
        id: "WgRR4GWNmlprQG6jxF8f9g",
        name: "1.5 XMA S",
        fuel_type: "diesel",
        cc: 1497,
        transmission_type: "automatic",
        is_popular: true,
      },
      {
        id: "8-wNLV8rS3bLFcWDI8g_ag",
        name: "XZ Plus Option",
        fuel_type: "petrol",
        cc: 1198,
        transmission_type: "manual",
        is_popular: true,
      },
      {
        id: "knfMVqYvuvuHbs3X0A8kug",
        name: "1.2 XZ Option Plus",
        fuel_type: "petrol",
        cc: 1199,
        transmission_type: "manual",
        is_popular: true,
      },
      {
        id: "ZBm_jrRQnWThao5hgTrrGw",
        name: "1.2 XZA Plus",
        fuel_type: "petrol",
        cc: 1199,
        transmission_type: "automatic",
        is_popular: true,
      },
      {
        id: "mZSrHCA-yriB35je3Nix7w",
        name: "1.2 XZA Plus Dark Edition",
        fuel_type: "petrol",
        cc: 1199,
        transmission_type: "automatic",
        is_popular: true,
      },
      {
        id: "70ijSE_nly_mVtrylVz2Og",
        name: "XZ Plus LUX",
        fuel_type: "petrol",
        cc: 1199,
        transmission_type: "manual",
        is_popular: true,
      },
      {
        id: "zPmj1RXoENgb_0RIiQh6cw",
        name: "XZA Plus Dual Tone",
        fuel_type: "diesel",
        cc: 1497,
        transmission_type: "automatic",
        is_popular: true,
      },
      {
        id: "BS5wS1y4uvyZ7Fk6bcBo8w",
        name: "1.2 XZA Plus (S)",
        fuel_type: "petrol",
        cc: 1199,
        transmission_type: "automatic",
        is_popular: true,
      },
      {
        id: "gSp7tAsYzRXOjjv8J0JgFw",
        name: "XZ Plus option Dual Tone",
        fuel_type: "petrol",
        cc: 1199,
        transmission_type: "manual",
        is_popular: true,
      },
      {
        id: "8HULStsuHIEof8JmjPqsHw",
        name: "1.2 XZ Plus Dark Edition HS",
        fuel_type: "petrol",
        cc: 1199,
        transmission_type: "manual",
        is_popular: true,
      },
      {
        id: "dgmnXKRMpdZkWwOwhrqCBQ",
        name: "XZ Plus (S) Dual tone",
        fuel_type: "petrol",
        cc: 1199,
        transmission_type: "manual",
        is_popular: true,
      },
      {
        id: "Veu_munrJXnRrlLJaLSkqQ",
        name: "XZ Plus LUX Dual Tone",
        fuel_type: "petrol",
        cc: 1199,
        transmission_type: "manual",
        is_popular: true,
      },
      {
        id: "CMEOl7Yni4_mrn-UQqwQTA",
        name: "1.2 XZ Option Plus Dark Edition",
        fuel_type: "petrol",
        cc: 1199,
        transmission_type: "manual",
        is_popular: true,
      },
      {
        id: "GwGHNz_1dZmt6PccdXPVOg",
        name: "1.5 XZ Plus (S)",
        fuel_type: "diesel",
        cc: 1497,
        transmission_type: "manual",
        is_popular: true,
      },
      {
        id: "O6Wkup6M_dfUAIh2VF7Xpw",
        name: "XZ Plus LUX Dark Edition",
        fuel_type: "petrol",
        cc: 1199,
        transmission_type: "manual",
        is_popular: true,
      },
      {
        id: "TFzUM0vkb9p5IhiKhtxSNw",
        name: "1.2 XZA Plus HS",
        fuel_type: "petrol",
        cc: 1199,
        transmission_type: "automatic",
        is_popular: true,
      },
      {
        id: "p5i1LDRQMS992vptjiTleQ",
        name: "XZ Plus Option Dual Tone",
        fuel_type: "diesel",
        cc: 1497,
        transmission_type: "manual",
        is_popular: true,
      },
      {
        id: "5TLasw5VaX2E7fPTSY9BPw",
        name: "1.5 XZ Plus Dark Edition",
        fuel_type: "diesel",
        cc: 1497,
        transmission_type: "manual",
        is_popular: true,
      },
      {
        id: "MKaHOwzn6u_nW8jxH6lc_Q",
        name: "XZA Plus Option",
        fuel_type: "petrol",
        cc: 1198,
        transmission_type: "manual",
        is_popular: true,
      },
      {
        id: "nryhOmHxqbeGrNPCjh6S8A",
        name: "1.2 XZA Option Plus",
        fuel_type: "petrol",
        cc: 1199,
        transmission_type: "automatic",
        is_popular: true,
      },
      {
        id: "itkXKxdo8IcHGmMtzhCwmw",
        name: "1.2 XZ Plus P",
        fuel_type: "petrol",
        cc: 1199,
        transmission_type: "manual",
        is_popular: true,
      },
      {
        id: "Cv2P5AwDBe7m19FgbpUayw",
        name: "XZA Plus LUX",
        fuel_type: "petrol",
        cc: 1199,
        transmission_type: "automatic",
        is_popular: true,
      },
      {
        id: "RCUzEY6W4ZzNG_tTMxMDCQ",
        name: "XZ Plus Luxs",
        fuel_type: "petrol",
        cc: 1199,
        transmission_type: "manual",
        is_popular: true,
      },
      {
        id: "PxkHPRMREXm8jz76c2P5ug",
        name: "1.2 XZA Plus Dark Edition HS",
        fuel_type: "petrol",
        cc: 1199,
        transmission_type: "automatic",
        is_popular: true,
      },
      {
        id: "4d1kObDvCtAJOT4bNZrgDw",
        name: "1.2 XZ Plus Kaziranga",
        fuel_type: "petrol",
        cc: 1199,
        transmission_type: "manual",
        is_popular: true,
      },
      {
        id: "dPmZFMw5yzxA7nE0KzRkRg",
        name: "XZ Plus Luxs Jet",
        fuel_type: "petrol",
        cc: 1199,
        transmission_type: "manual",
        is_popular: true,
      },
      {
        id: "wx8tnn8kBEFr6rdvdTxDvw",
        name: "XZA Plus (S) Dual tone",
        fuel_type: "petrol",
        cc: 1199,
        transmission_type: "automatic",
        is_popular: true,
      },
      {
        id: "b96QYZISBz1VCjtvbkGrIQ",
        name: "XZA Plus LUX Dual Tone",
        fuel_type: "petrol",
        cc: 1199,
        transmission_type: "automatic",
        is_popular: true,
      },
      {
        id: "rDdX7XMR7W4gwKFlSbowTg",
        name: "XZ Plus Luxs Dark Edition",
        fuel_type: "petrol",
        cc: 1199,
        transmission_type: "manual",
        is_popular: true,
      },
      {
        id: "5xeDihuAPj4mumS98bCCCw",
        name: "XZ Plus LUXS Kaziranga",
        fuel_type: "petrol",
        cc: 1199,
        transmission_type: "manual",
        is_popular: true,
      },
      {
        id: "s7k__wKk72U_gx-OH5vbgg",
        name: "1.5 XZA Plus (S)",
        fuel_type: "diesel",
        cc: 1497,
        transmission_type: "automatic",
        is_popular: true,
      },
      {
        id: "7P7hdrcCkwSWb0hfR32vog",
        name: "1.2 XZA Option Plus Dark Edition",
        fuel_type: "petrol",
        cc: 1199,
        transmission_type: "automatic",
        is_popular: true,
      },
      {
        id: "_v3jssXklEFm5zr4mcDNuw",
        name: "XZ Plus LUXS Dual Tone",
        fuel_type: "petrol",
        cc: 1199,
        transmission_type: "manual",
        is_popular: true,
      },
      {
        id: "mQSl1ErNmqj49q0kA0esuQ",
        name: "XZA Plus LUX Dark Edition",
        fuel_type: "petrol",
        cc: 1199,
        transmission_type: "automatic",
        is_popular: true,
      },
      {
        id: "N7jvq1iDoATjq-rdesSjaQ",
        name: "1.5 XZ Plus HS",
        fuel_type: "diesel",
        cc: 1497,
        transmission_type: "manual",
        is_popular: true,
      },
      {
        id: "WhjaC8uprPUahdDsZtnTtQ",
        name: "XZ Plus LUXS Red Dark",
        fuel_type: "petrol",
        cc: 1199,
        transmission_type: "manual",
        is_popular: true,
      },
      {
        id: "waxyk-bYPj4U4Jp9mcXuew",
        name: "1.5 XZA Plus Dark Edition",
        fuel_type: "diesel",
        cc: 1497,
        transmission_type: "automatic",
        is_popular: true,
      },
      {
        id: "kA7GUrLHX4lr-d_FW7cZ0A",
        name: "XZ Plus Option",
        fuel_type: "diesel",
        cc: 1497,
        transmission_type: "automatic",
        is_popular: true,
      },
      {
        id: "XuV2gaP41BoRZm4ZO4C-Vg",
        name: "facelift xz Plus Option singal tone",
        fuel_type: "diesel",
        cc: 1497,
        transmission_type: "manual",
        is_popular: true,
      },
      {
        id: "LE24gleEhZ3w6bwiY1UGSw",
        name: "1.5 XZ Plus HS Dual Tone",
        fuel_type: "diesel",
        cc: 1497,
        transmission_type: "manual",
        is_popular: true,
      },
      {
        id: "rveiCxEpDknMgM7Nye_LKQ",
        name: "XZA Plus LUXS",
        fuel_type: "petrol",
        cc: 1199,
        transmission_type: "automatic",
        is_popular: true,
      },
      {
        id: "TYJNIRd6SWcowtMwXDs3-w",
        name: "1.5 XZ Plus Dark Edition HS",
        fuel_type: "diesel",
        cc: 1497,
        transmission_type: "manual",
        is_popular: true,
      },
      {
        id: "eaNGkbMZnHu_vKSJVMdXJg",
        name: "XZ Plus Lux",
        fuel_type: "diesel",
        cc: 1497,
        transmission_type: "manual",
        is_popular: true,
      },
      {
        id: "K2-hZUtFxT0miGwlY2yA9Q",
        name: "1.2 XZA Plus Kaziranga",
        fuel_type: "petrol",
        cc: 1199,
        transmission_type: "automatic",
        is_popular: true,
      },
      {
        id: "dCT2SSZPfa6CbPyFtlKIsQ",
        name: "XZA Plus Luxs Jet",
        fuel_type: "petrol",
        cc: 1199,
        transmission_type: "automatic",
        is_popular: true,
      },
      {
        id: "IbLjje2gEGxBETAp5u5D7A",
        name: "XZ Plus Lux Dual Tone",
        fuel_type: "diesel",
        cc: 1497,
        transmission_type: "manual",
        is_popular: true,
      },
      {
        id: "fO141XRZUi4RD4H0LaXXXw",
        name: "XZA Plus LUXS Dark Edition",
        fuel_type: "petrol",
        cc: 1199,
        transmission_type: "automatic",
        is_popular: true,
      },
      {
        id: "E3piUm8OVsLpYrxpIvTIaA",
        name: "XZA Plus LUXS Kaziranga",
        fuel_type: "petrol",
        cc: 1199,
        transmission_type: "automatic",
        is_popular: true,
      },
      {
        id: "jmW3HAbyDlyvteo9m9KNUQ",
        name: "1.5 XZ Option Plus Dark Edition",
        fuel_type: "diesel",
        cc: 1497,
        transmission_type: "manual",
        is_popular: true,
      },
      {
        id: "q0wDZ0zWugLKGzbZjbknuQ",
        name: "XZA Plus LUXS Dual Tone",
        fuel_type: "petrol",
        cc: 1199,
        transmission_type: "automatic",
        is_popular: true,
      },
      {
        id: "wRRFJAOA5rTPEEcfmTyDBA",
        name: "XZ Plus LUX Dark Edition",
        fuel_type: "diesel",
        cc: 1497,
        transmission_type: "manual",
        is_popular: true,
      },
      {
        id: "gsABNtivyUr9ptvwB_4Nvw",
        name: "XZA Plus LUXS Red Dark AMT",
        fuel_type: "petrol",
        cc: 1199,
        transmission_type: "automatic",
        is_popular: true,
      },
      {
        id: "VJGhq7N3JeB0tNFKjaenpw",
        name: "XZA Plus LUXS Red Dark Edition",
        fuel_type: "petrol",
        cc: 1199,
        transmission_type: "automatic",
        is_popular: true,
      },
      {
        id: "hDaj74mG3m_VFHO_3gOzig",
        name: "XZA Plus Option",
        fuel_type: "diesel",
        cc: 1497,
        transmission_type: "automatic",
        is_popular: true,
      },
      {
        id: "uD_d-na599-QcgiFC5Dgqg",
        name: "XZ Plus Luxs",
        fuel_type: "diesel",
        cc: 1497,
        transmission_type: "manual",
        is_popular: true,
      },
      {
        id: "iZn04uGupQli5BuI5Thwvg",
        name: "XZ Plus LUXS Dark Edition",
        fuel_type: "diesel",
        cc: 1497,
        transmission_type: "manual",
        is_popular: true,
      },
      {
        id: "sUXw3NvSXXfEmEGdLwkLPQ",
        name: "XZA Plus LUX",
        fuel_type: "diesel",
        cc: 1497,
        transmission_type: "automatic",
        is_popular: true,
      },
      {
        id: "XU6hX_Yg9CCsSHw-uTHrJA",
        name: "1.5 XZA Plus Dark Edition HS",
        fuel_type: "diesel",
        cc: 1497,
        transmission_type: "automatic",
        is_popular: true,
      },
      {
        id: "7aYBdem2W6GxY-nx7usnow",
        name: "1.5 XZ Plus Kaziranga",
        fuel_type: "diesel",
        cc: 1497,
        transmission_type: "manual",
        is_popular: true,
      },
      {
        id: "gUT5DajqcosmAnYjtE5Nkw",
        name: "XZ Plus Luxs Jet",
        fuel_type: "diesel",
        cc: 1497,
        transmission_type: "manual",
        is_popular: true,
      },
      {
        id: "2cKklJ_rztWCGISEC6NA1w",
        name: "XZA Plus LUX Dual Tone",
        fuel_type: "diesel",
        cc: 1497,
        transmission_type: "automatic",
        is_popular: true,
      },
      {
        id: "zv5V1KkH4Qzwb2Xysn2MIQ",
        name: "1.5 XZA Option Plus Dark Edition",
        fuel_type: "diesel",
        cc: 1497,
        transmission_type: "automatic",
        is_popular: true,
      },
      {
        id: "O5daGK1klgC-fi5T5okQ6A",
        name: "XZ Plus LUXS Kaziranga",
        fuel_type: "diesel",
        cc: 1497,
        transmission_type: "manual",
        is_popular: true,
      },
      {
        id: "cg4GrnSLJsMIbrfbVWvZQw",
        name: "XZ Plus LUXS Dual Tone",
        fuel_type: "diesel",
        cc: 1497,
        transmission_type: "manual",
        is_popular: true,
      },
      {
        id: "3myqwWUz2H-y7vK8OYr-QQ",
        name: "XZA Plus LUX Dark Edition",
        fuel_type: "diesel",
        cc: 1497,
        transmission_type: "automatic",
        is_popular: true,
      },
      {
        id: "zE6HLYx0pBkQXzvopCjSbQ",
        name: "XZ Plus LUXS Red Dark",
        fuel_type: "diesel",
        cc: 1497,
        transmission_type: "manual",
        is_popular: true,
      },
      {
        id: "fbMPHMQFtH6xpQ0NRNVCUg",
        name: "1.5 XZA Plus P",
        fuel_type: "diesel",
        cc: 1497,
        transmission_type: "automatic",
        is_popular: true,
      },
      {
        id: "FS5qM518xG7S0y_jV_CwFA",
        name: "1.5 XZA Plus Kaziranga",
        fuel_type: "diesel",
        cc: 1497,
        transmission_type: "automatic",
        is_popular: true,
      },
      {
        id: "CA4l2yI9Vy9i4ifNmIDhqA",
        name: "XZA Plus Luxs Jet",
        fuel_type: "diesel",
        cc: 1497,
        transmission_type: "automatic",
        is_popular: true,
      },
      {
        id: "w37J0QKccEtFh_8W87quQA",
        name: "XZA Plus LUXS Dark Edition",
        fuel_type: "diesel",
        cc: 1497,
        transmission_type: "automatic",
        is_popular: true,
      },
      {
        id: "v2J2tq81QG7XnehOhjrZ0g",
        name: "XZA Plus LUXS Kaziranga",
        fuel_type: "diesel",
        cc: 1497,
        transmission_type: "automatic",
        is_popular: true,
      },
      {
        id: "waZyWM7rB0rrPWDnmT9s1g",
        name: "XZA Plus LUXS",
        fuel_type: "diesel",
        cc: 1497,
        transmission_type: "automatic",
        is_popular: true,
      },
      {
        id: "tGonUm0NwUT09jm3bo5xGg",
        name: "XZA Plus LUXS Red Dark AMT",
        fuel_type: "diesel",
        cc: 1497,
        transmission_type: "automatic",
        is_popular: true,
      },
      {
        id: "_KKoCyshqp6wLKqgJ5AUZA",
        name: "XZA Plus LUXS Dual Tone",
        fuel_type: "diesel",
        cc: 1497,
        transmission_type: "automatic",
        is_popular: true,
      },
    ],
    image: "vehicles/Tata/Tata-Nexon/white.png",
    priority: 1009,
    is_popular_model: true,
  }
]

export const POPULAR_MAKE_NAMES = Object.keys(
  organizeCarsByMake(SAMPLE_POPULAR_VEHICLE_DATA),
);

export const POPULAR_MODEL_NAMES = (make) => organizeCarsByMake[make];

// mapping as VEHICLE_MAKE (key) : SVG_IMAGE_FOR_VEHICLE_MAKE (value)
// TODO: GET ACTUAL RESPONSE IN THE API IN THE CORRECT FORMAT INCLUDING SVGS (currently keeping in ui)
export const MakeImageConfig = {
  TATA: TataIcon,
  MAHINDRA: MahindraIcon,
  HONDA: HondaDummyAsBmwIcon,
  MARUTI: MarutiIcon,
  HYUNDAI: HyundaiIcon,
  KIA: KiaDummyAsJaguarIcon
};

export const SAMPLE_REG_YEARS = () => {
  const now = new Date().getUTCFullYear();
  return Array(now - (now - 20))
    .fill("")
    .map((v, idx) => now - idx);
}

export function getObjectProperty(obj, property) {
  return Object.keys(obj).reduce((acc, key) => {
    acc[key] = obj[key][property];
    return acc;
  }, {});
}

export const newMakeData = getObjectProperty(MMV_DATA, "logo")

export const formatVariantsDataByFuelType = (makeName, modelName, MMV_DATA, defaultVariant) => {
  if (!makeName || !modelName || isEmpty(MMV_DATA)) {
    return defaultVariant ? {name: defaultVariant} : null;
  }
  const makeData = MMV_DATA?.[makeName];
  console.log('shared mmv-data', {makeName, modelName, makeData, MMV_DATA, defaultVariant, makeData})
  const modelData = makeData?.models?.filter(data => data?.model_name === modelName);
  const formattedVariants = modelData?.[0]?.variants?.reduce(
    (acc, currvariant) => {
      const { fuel_type } = currvariant;
      if (!acc[fuel_type]) {
        acc[fuel_type] = [];
      }
      acc[fuel_type].push(currvariant);
      return acc;
    },
    {}
  );

  return formattedVariants;

}
